var nurseslounge_myDashboard_myProfile = {
    init:function($params){
        //nurseslounge_myDashboard_activity.lounge_follow_request(function($chtml){
        //    nurseslounge_myDashboard_myProfile.lounge_follow_container($chtml);
        //});
        nurseslounge_myDashboard_myProfile.banners_location(function($config){
            nurseslounge_myDashboard_myProfile.banners_engine($config);
        });
        nurseslounge_myDashboard_myProfile.connect_with(function($config){
            nurseslounge_myDashboard_myProfile.connect_engine($config);
        });
        nurseslounge_myDashboard_colleagues.recommended_friends(function($chtml){
            nurseslounge_myDashboard_myProfile.recommended_friends_container($chtml);
        });
        nurseslounge_myDashboard_myProfile.profile($params);
        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true);
        nurseslounge_myDashboard_myProfile.task_list_container(function($container){
            nurseslounge_myDashboard_myProfile.task_list($container, $params);
        });
        nurseslounge_myDashboard_myProfile.preview_profile_container(function($container){
            nurseslounge_myDashboard_myProfile.preview_profile($container, $params);
        });
        nurseslounge_myDashboard_myProfile.download_pdf_container(function($container){
            nurseslounge_myDashboard_myProfile.download_pdf($container, $params);
        });
        nurseslounge_myDashboard_myProfile.notification_link();
        nurseslounge_myDashboard_myProfile.lounge_ads_location(function($config){
            nurseslounge_lounge_overview.lounge_ads_engine($config);
        });
        nurseslounge_myDashboard_myProfile.spotlight_container(function($container){
            nurseslounge_myDashboard_myProfile.spotlight($container, $params);
        });
        //nurseslounge_myDashboard_myProfile.coin_list($params, true, function($eventsIds){
        //   nurseslounge_myDashboard_myProfile.coin_events($params, $eventsIds);
        //});
    },
    //General
    general_autocomplete:function($form, $id, $target, $url, $optional, $data){
        if($data == undefined){$data = {};}
        try {
            $($form+" "+$id).autocomplete("destroy");
        }catch (e) {
        }
        var $arrId = [];
        var $arrData = [];
        var $value = '';
        $($form+" "+$id).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({}, $data, {
                        value:$($form+" "+$id).val()
                    }),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        response($data);
                        /*
                        $arrId.length = 0;
                        $arrData.length = 0;
                        $value = '';
                        $.each($data,function($i,$v){
                            $arrData.push('"'+$v.value+'"');
                            $arrId.push([$v.id, $v.value]);
                        });
                        $arrData = $arrData.sort();
                        $arrData = $.unique($arrData);
                        response(JSON.parse("["+$arrData.join(",")+"]"));
                         */
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            /*
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value).blur();
                if($optional == 0){
                    $($form+" "+$target).val('');
                }
                $.each($arrId,function($i,$v){
                    if($.trim($v[1]) == $.trim($value)){
                        $($form+" "+$target).val($v[0]);
                        $($form).valid();
                    }
                });
                return false;
            },
            focus: function (event, ui) {
                event.preventDefault();
                $value = ui.item.value;
                $(this).val($value);
                if($optional == 0) {
                    $($form + " " + $target).val('');
                }
                $.each($arrId, function ($i, $v) {
                    if ($.trim($v[1]) == $.trim($value)) {
                        $($form + " " + $target).val($v[0]);
                    }
                });
                return false;
            }
            */
        }).blur(function(event){
            if($optional == 0) {
                $($form + " " + $id).val($value);
                $($form + " " + $target).val('');
            }
            $.each($arrId, function ($i, $v) {
                if ($.trim($v[1]) == $.trim($value)) {
                    $($form + " " + $target).val($v[0]);
                }
            });
        }).focus(function(){
            $(this).autocomplete("search","");
            $(this).trigger("keypress.autocomplete");
        }).click(function(){
            $(this).autocomplete("search","");
            $(this).trigger($.Event("keydown",{keyCode:40}));
        });

    },
    multiple_autocomplete:function($form, $id, $url, $data){
        if($data == undefined){$data = {};}
        try {
            $($form+" "+$id).autocomplete("destroy");
        }catch (e) {
        }
        var $arrId = [];
        var $arrData = [];
        var $value = '';
        $($form+" "+$id).unbind()
            .on("keydown", function( event ) {
                if (event.keyCode === $.ui.keyCode.TAB && $(this).autocomplete("instance").menu.active) {
                    event.preventDefault();
                }
            })
            .autocomplete({
                minLength	:2,
                search		: function(){
                    $(this).addClass("ui-autocomplete-loading");
                },
                open 		: function(){
                    $(this).removeClass("ui-autocomplete-loading");
                },
                source: function(request, response) {
                    $.ajax({
                        method: 'POST',
                        url:$url,
                        data:$.extend(
                            {},
                            $data,
                            {value:$($form+" "+$id).val().split(/,\s*/).pop()}
                        ),
                        dataType: "json",
                        success: function($data){
                            libs.expire($data);
                            $arrId.length = 0;
                            $arrData.length = 0;
                            $value = '';
                            $.each($data,function($i,$v){
                                $arrData.push('"'+$v.value+'"');
                                $arrId.push([$v.id, $v.value]);
                            });
                            response(JSON.parse("["+$arrData.join(",")+"]"));
                        }
                    });
                },
                select: function (event, ui) {
                    var $value = $($form+" "+$id).val().split(/,\s*/);
                    $value.pop();
                    $value.push(ui.item.value);
                    $value.push("");
                    this.value = $value.join(", ");
                    return false;
                },
                focus: function (event, ui) {
                    event.preventDefault();
                    return false;
                }
            });
    },
    //User Degrees
    profile:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $profile = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-info:first');
        $profile.find(".edit-profile:first").unbind().click(function(){
            nurseslounge_myDashboard_myProfile.profile_is_complete($params, false, function(){
                nurseslounge_myDashboard_myProfile.user_profile_fill($params, false);
            });
        });
        nurseslounge_myDashboard_myProfile.profile_events($params);
    },
    profile_events:function($params){
        nurseslounge_myDashboard_myProfile.about_my_career($params);
        nurseslounge_myDashboard_myProfile.degree($params);
        nurseslounge_myDashboard_myProfile.specialty($params);
        nurseslounge_myDashboard_myProfile.experience($params);
        nurseslounge_myDashboard_myProfile.education($params);
        nurseslounge_myDashboard_myProfile.license($params);
        nurseslounge_myDashboard_myProfile.certification($params);
        nurseslounge_myDashboard_myProfile.memberships($params);
        nurseslounge_myDashboard_myProfile.volunteer($params);
        nurseslounge_myDashboard_myProfile.research($params);
        nurseslounge_myDashboard_myProfile.publications($params);
        nurseslounge_myDashboard_myProfile.presentations($params);
        nurseslounge_myDashboard_myProfile.awards($params);
        nurseslounge_myDashboard_myProfile.add_cards($params);
        nurseslounge_myDashboard_myProfile.collapse_events();
        libs.refreshTooltips();
    },
    collapse_events:function(){
        $(".read-more").unbind().click(function($e){
            $e.stopPropagation();
            var $that = $(this);
            if($that.is(':visible')){
                var $id = $that.parents('.description:first').find('.collapse').attr('id');
                nurseslounge_myDashboard_myProfile.collapse_smooth($that, $id);
            }
        });
        $(".top-read-more").unbind().click(function(){
            var $that = $(this).find('.read-more:first');
            if($that.is(':visible')){
                var $id = $that.parents('.description:first').find('.collapse').attr('id');
                nurseslounge_myDashboard_myProfile.collapse_smooth($that, $id);
            }
        });
    },
    collapse_smooth:function($that, $id){
        var $original = $("#"+$id).height();
        var $duration = ($original * 0.8);
        $("#"+$id).height(0);
        $("#"+$id).animate({
            height:$original
        }, $duration,"linear", function() {
            $("#"+$id).find('.read-less').unbind().click(function($e) {
                $e.stopPropagation();
                $("#"+$id).removeClass('d-inline');
                $("#"+$id).animate({
                    height: '0px'
                }, $duration,"linear", function(){
                    $that.attr('style', '');
                    $("#"+$id).attr('style', '');
                    $that.show();
                    $("#"+$id).hide();
                    nurseslounge_myDashboard_myProfile.collapse_events();
                });
            });
            $that.hide();
            $("#"+$id).addClass('d-inline');
        });
    },
    about_my_career:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $career = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-about-my-career:first');
        var $careerModal = $('#home-my-profile-left-profile-about-my-career-modal');
        $career.find('.edit-aboutMyCareer:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'about'}, {action:'get'}, $params), function($data){
                $careerModal.find("textarea[name='aboutMyCareer']").val($data.data.summary);
                nurseslounge_myDashboard_myProfile.about_my_career_validate(function($form){
                    nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'about'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $careerModal.modal('hide');
                        });
                    });
                });
                $careerModal.find('.delete-aboutMyCareer:first').unbind().click(function(){
                    nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'about'}, {action:'delete'}, $params), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $careerModal.modal('hide');
                        });
                    });
                });
                $careerModal.modal('show');
            });
        });
    },
    about_my_career_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-about-my-career-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-about-my-career-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                aboutMyCareer: {
                    required: true
                }
            },
            messages: {
                aboutMyCareer: {
                    required: "About my career is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-about-my-career-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-about-my-career-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-about-my-career-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    degree:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $degree = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-degrees:first');
        var $degreeModal = $('#home-my-profile-left-profile-degrees-modal');
        $degree.find('.edit-degree').unbind().click(function(){
            var $id = $(this).data('id');
            nurseslounge_myDashboard_myProfile.degree_request($.extend({}, {action:'get'}, {id:$id},  $params), function($data){
                $degreeModal.find("label[name='degree']").html($data.data.user_degree.degree.type);
                $degreeModal.find("textarea[name='description']").val($data.data.user_degree.description);
                $degreeModal.find("select[name='startDateMonth']").val($data.data.user_degree.start_month);
                $degreeModal.find("select[name='startDateYear']").val($data.data.user_degree.start_year);
                $degreeModal.find("select[name='endDateMonth']").val($data.data.user_degree.end_month);
                $degreeModal.find("select[name='endDateYear']").val($data.data.user_degree.end_year);
                $degreeModal.find("input[name='currentlyAttending']").prop('checked', $data.data.user_degree.currently_attending == 1);
                nurseslounge_myDashboard_myProfile.degree_validate(function($form){
                    nurseslounge_myDashboard_myProfile.degree_request($.extend({}, {action:'set'}, {id:$id}, $params, libs.getObjForm($form)), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $degreeModal.modal('hide');
                        });
                    });
                });
                $degreeModal.find('.delete-degree').unbind().click(function(){
                    nurseslounge_myDashboard_myProfile.degree_request($.extend({}, {action:'delete'}, {id:$id}, $params), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $degreeModal.modal('hide');
                        });
                    });
                });
                $degreeModal.modal('show');
            });
        });
    },
    degree_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-degrees-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $.validator.addMethod("compareDates",
            function($val, $ele, $param) {
                var $sYear = $("#home-my-profile-left-profile-degrees-modal form select[name='startDateYear']").val();
                var $sMonth = $("#home-my-profile-left-profile-degrees-modal form select[name='startDateMonth']").val();
                var $eYear = $("#home-my-profile-left-profile-degrees-modal form select[name='endDateYear']").val();
                var $eMonth = $("#home-my-profile-left-profile-degrees-modal form select[name='endDateMonth']").val();
                if(
                    $sYear != '' && $sMonth != '' && $eYear!= '' && $eMonth!='' &&
                    !$("#home-my-profile-left-profile-degrees-modal form input[name='currentlyAttending']").is(':checked')
                ){
                    return parseInt(new Date($sYear, $sMonth).getTime()) < parseInt(new Date($eYear, $eMonth).getTime());
                }else{
                    return true;
                }
            },'Dates error {0}.');
        $validator = $("#home-my-profile-left-profile-degrees-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                description: {
                    required: true
                },
                startDateMonth: {
                    required: true,
                    compareDates:true
                },
                startDateYear: {
                    required: true,
                    compareDates:true
                },
                endDateMonth: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-degrees-modal form input[name='currentlyAttending']").is(':checked')
                    },
                    compareDates:true
                },
                endDateYear: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-degrees-modal form input[name='currentlyAttending']").is(':checked')
                    },
                    compareDates:true
                },
            },
            messages: {
                description: {
                    required: "Description is required"
                },
                startDateMonth: {
                    required: "Start month is required",
                    compareDates: "Start date is higher than end date"
                },
                startDateYear: {
                    required: "Start year is required",
                    compareDates: "Start date is higher than end date"
                },
                endDateMonth: {
                    required: "End month is required",
                    compareDates: "End date is lower than start date"
                },
                endDateYear: {
                    required: "End year is required",
                    compareDates: "End date is lower than start date"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-degrees-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-degrees-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-degrees-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    degree_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/degree/getSet",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback($data);
                }
            }
        });
    },
    specialty:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $specialty = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-specialty:first');
        var $specialtyModal = $('#home-my-profile-left-profile-specialty-modal');
        $specialty.find('.edit-specialty').unbind().click(function(){
            var $id = $(this).data('id');
            nurseslounge_myDashboard_myProfile.specialty_request($.extend({}, {action:'get'}, {id:$id},  $params), function($data){
                $specialtyModal.find("label[name='specialty']").html($data.data.user_specialty.specialty.type);
                $specialtyModal.find("textarea[name='description']").val($data.data.user_specialty.description);
                nurseslounge_myDashboard_myProfile.specialty_validate(function($form){
                    nurseslounge_myDashboard_myProfile.specialty_request($.extend({}, {action:'set'}, {id:$id}, $params, libs.getObjForm($form)), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $specialtyModal.modal('hide');
                        });
                    });
                });
                $specialtyModal.find('.delete-specialty').unbind().click(function(){
                    nurseslounge_myDashboard_myProfile.specialty_request($.extend({}, {action:'delete'}, {id:$id}, $params), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $specialtyModal.modal('hide');
                        });
                    });
                });
                $specialtyModal.modal('show');
            });
        });
    },
    specialty_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-specialty-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-specialty-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                description: {
                    required: true
                },
            },
            messages: {
                description: {
                    required: "Description is required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-specialty-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-specialty-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-specialty-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    specialty_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/specialty/getSet",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback($data);
                }
            }
        });
    },
    experience:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $experience = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-experience:first');
        var $experienceModal = $('#home-my-profile-left-profile-experience-modal');
        var $employerNameInput = $("#home-my-profile-left-profile-experience-modal form input[name='employerName']");
        var $otherEmployer = $("#home-my-profile-left-profile-experience-modal form .otherEmployer");
        var $employerOptions = $("#home-my-profile-left-profile-experience-modal form .employerOptions");
        var $binding;
        $otherEmployer.hide();
        $employerOptions.html('');
        $employerNameInput.unbind();
        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#home-my-profile-left-profile-experience-modal form",
            "input[name='employerName']",
            null,"/myDashboard/myProfile/employers/autocomplete",
            1,
            $.extend({}, $params, {type:['employers', 'schools']})
        );
        $employerNameInput.on('blur', function(){
            var $that = $(this);
            var $val = $that.val();
            var $index = $val.indexOf("(");
            if($index > 0){
                $val = $val.substring(0,$index);
            }
            var $newParams = $.extend({}, $params, {employer:$val});
            try{
                clearTimeout($binding);
            }catch (e) {
            }
            $binding = setTimeout(function(){
                $otherEmployer.hide();
                $employerOptions.html('');
                nurseslounge_myDashboard_myProfile.experience_check_lounge($newParams);
            }, 800);
        });
        var $inputAutocomplete = $experienceModal.find('input[name="location"]')[0];
        new google.maps.places.Autocomplete($inputAutocomplete,{
            types: ['(regions)'],
            componentRestrictions: {country: "us"}
        });
        $experience.find('.edit-experience').unbind().click(function(){
            $experienceModal.find('.delete-experience').show();
            $experienceModal.find('.save-experience').html('Save');
            var $id = $(this).data('id');
            nurseslounge_myDashboard_myProfile.experience_request($.extend({}, {action:'get'}, {id:$id},  $params), function($data){
                $experienceModal.find("input[name='jobTitle']").val($data.data.user_experience.job_title);
                $experienceModal.find("input[name='employerName']").val($data.data.user_experience.employer_name);
                $experienceModal.find("input[name='location']").val($data.data.user_experience.location);
                $experienceModal.find("textarea[name='description']").val($data.data.user_experience.description);
                $experienceModal.find("select[name='startDateMonth']").val($data.data.user_experience.start_month);
                $experienceModal.find("select[name='startDateYear']").val($data.data.user_experience.start_year);
                $experienceModal.find("select[name='endDateMonth']").val($data.data.user_experience.end_month);
                $experienceModal.find("select[name='endDateYear']").val($data.data.user_experience.end_year);
                $experienceModal.find("input[name='presentEmployer']").prop('checked', $data.data.user_experience.present_employer == 1);
                nurseslounge_myDashboard_myProfile.experience_validate(function($form){
                    nurseslounge_myDashboard_myProfile.experience_request($.extend({}, {action:'set'}, {id:$id}, $params, libs.getObjForm($form)), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $experienceModal.modal('hide');
                        });
                    });
                });
                $experienceModal.find('.delete-experience').unbind().click(function(){
                    nurseslounge_myDashboard_myProfile.experience_request($.extend({}, {action:'delete'}, {id:$id}, $params), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $experienceModal.modal('hide');
                        });
                    });
                });
                $experienceModal.modal('show');
            });
        });
        $experience.find('.add-experience').unbind().click(function(){
            $experienceModal.find('form')[0].reset();
            $experienceModal.find('.delete-experience').hide();
            $experienceModal.find('.save-experience').html('Create');
            nurseslounge_myDashboard_myProfile.experience_validate(function($form){
                nurseslounge_myDashboard_myProfile.experience_request($.extend({}, {action:'create'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $experienceModal.modal('hide');
                    });
                });
            });
            $experienceModal.modal('show');
        });
        $experience.find('.add-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_myDashboard_myProfile.lounge_review_get_request($params, function($data){
                var $typeId = $data.data.lounge.lounge_type_id;
                var $link = $data.data.lounge.link;
                nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                    router.navigate($link+'/ratingReviews',true);
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                });
            });
        });
        $experience.find('.edit-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_myDashboard_myProfile.lounge_review_get_request($params, function($data){
                var $typeId = $data.data.lounge.lounge_type_id;
                var $link = $data.data.lounge.link;
                nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                    });
                });
            });
        });
        $experience.find('.delete-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            $params = $.extend({}, $params, {key:$key});
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                    });
                });
            }
        });
    },
    lounge_review_get_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/myProfile/getLoungeReview",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    experience_check_lounge:function($params){
        var $employerNameInput = $("#home-my-profile-left-profile-experience-modal form input[name='employerName']");
        var $locationInput = $("#home-my-profile-left-profile-experience-modal form input[name='location']");
        var $otherEmployer = $("#home-my-profile-left-profile-experience-modal form .otherEmployer");
        var $employerOptions = $("#home-my-profile-left-profile-experience-modal form .employerOptions");
        nurseslounge_myDashboard_myProfile.experience_check_lounge_request($params, function($data){
            var $lounges = $data.data.lounges;
            if($data.data.list == 1){
                var $chtml = '';
                $.each($lounges, function($i, $v){
                    $chtml += '' +
                        '<div class="border p-3 employer-option" data-location="'+$v.location.address_state+'" data-name="'+$v.name+'">' +
                        '   <img src="'+$v.logo_root_lounge+'?resize=50" class="img-fluid border mx-2 employer-image">' +
                            $v.name +
                        '</div>';
                });
                $employerOptions.html($chtml).promise().done(function(){
                    var $employerOption = $employerOptions.find('.employer-option');
                    $employerOption.unbind().click(function(){
                        var $that = $(this);
                        var $location = $that.data('location');
                        var $name = $that.data('name');
                        var $employerNameInputVal = $employerNameInput.val().trim();
                        var $index = $employerNameInputVal.indexOf(" (");
                        if($index > 0){
                            $employerNameInputVal = $employerNameInputVal.substring(0,$index);
                        }
                        $employerNameInput.val($employerNameInputVal+' ('+$name+')');
                        $locationInput.val($location);
                        $otherEmployer.hide();
                        $employerOptions.html('');
                    });
                });
                if($lounges.length > 0){
                    $otherEmployer.show();
                }
            }else{
                var $employerNameInputVal = $employerNameInput.val().trim();
                var $index = $employerNameInputVal.indexOf(" (");
                if($index > 0){
                    $employerNameInputVal = $employerNameInputVal.substring(0,$index);
                }
                if($lounges[0].name != $employerNameInputVal){
                    $employerNameInput.val($employerNameInputVal+' ('+$lounges[0].name+')');
                }
                $locationInput.val($lounges[0].location.address_state);
                $otherEmployer.hide();
                $employerOptions.html('');
            }
        });
    },
    experience_check_lounge_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/employers/validate",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    experience_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-experience-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $.validator.addMethod("compareExperienceDates",
            function($val, $ele, $param) {
                var $sYear = $("#home-my-profile-left-profile-experience-modal form select[name='startDateYear']").val();
                var $sMonth = $("#home-my-profile-left-profile-experience-modal form select[name='startDateMonth']").val();
                var $eYear = $("#home-my-profile-left-profile-experience-modal form select[name='endDateYear']").val();
                var $eMonth = $("#home-my-profile-left-profile-experience-modal form select[name='endDateMonth']").val();
                if(
                    $sYear != '' && $sMonth != '' && $eYear!= '' && $eMonth!='' &&
                    !$("#home-my-profile-left-profile-experience-modal form input[name='presentEmployer']").is(':checked')
                ){
                    return parseInt(new Date($sYear, $sMonth).getTime()) < parseInt(new Date($eYear, $eMonth).getTime());
                }else{
                    return true;
                }
            },'Dates error {0}.');
        $validator = $("#home-my-profile-left-profile-experience-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                jobTitle: {
                    required: true
                },
                employerName: {
                    required: true
                },
                location: {
                    required: true
                },
                description: {
                    required: false
                },
                startDateMonth: {
                    required: true,
                    compareExperienceDates:true
                },
                startDateYear: {
                    required: true,
                    compareExperienceDates:true
                },
                endDateMonth: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-experience-modal form input[name='presentEmployer']").is(':checked')
                    },
                    compareExperienceDates:true
                },
                endDateYear: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-experience-modal form input[name='presentEmployer']").is(':checked')
                    },
                    compareExperienceDates:true
                },
            },
            messages: {
                jobTitle: {
                    required: "Job title is required"
                },
                employerName: {
                    required: "Employer name is required"
                },
                location: {
                    required: "Location is required"
                },
                description: {
                    required: "Description is not required"
                },
                startDateMonth: {
                    required: "Start month is required",
                    compareExperienceDates: "Start date is higher than end date"
                },
                startDateYear: {
                    required: "Start year is required",
                    compareExperienceDates: "Start date is higher than end date"
                },
                endDateMonth: {
                    required: "End month is required",
                    compareExperienceDates: "End date is lower than start date"
                },
                endDateYear: {
                    required: "End year is required",
                    compareExperienceDates: "End date is lower than start date"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-experience-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-experience-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-experience-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    experience_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/experience/getSet",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    if($data.data.msg != ''){
                        if(window.location.pathname == '/myDashboard/myProfile') {
                            nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                    }
                    cback($data);
                }
            }
        });
    },
    education:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $education = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-education:first');
        var $educationModal = $('#home-my-profile-left-profile-education-modal');
        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#home-my-profile-left-profile-education-modal form",
            "input[name='schoolName']",
            null,
            "/myDashboard/myProfile/employers/autocomplete",
            1,
            $.extend({}, $params, {type:['schools']})
        );
        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#home-my-profile-left-profile-education-modal form",
            "input[name='degreeName']",
            null,
            "/myDashboard/myProfile/degrees/autocomplete",
            1,
            $params
        );
        var $inputAutocomplete = $educationModal.find('input[name="location"]')[0];
        new google.maps.places.Autocomplete($inputAutocomplete, {
            types: ['(regions)'],
            componentRestrictions: {country: "us"}
        });
        $education.find('.edit-education').unbind().click(function(){
            $educationModal.find('.delete-education').show();
            $educationModal.find('.save-education').html('Save');
            var $id = $(this).data('id');
            nurseslounge_myDashboard_myProfile.education_request($.extend({}, {action:'get'}, {id:$id},  $params), function($data){
                $educationModal.find("input[name='schoolName']").val($data.data.user_education.school_name);
                $educationModal.find("input[name='degreeName']").val($data.data.user_education.other_degree);
                $educationModal.find("input[name='location']").val($data.data.user_education.location);
                $educationModal.find("textarea[name='description']").val($data.data.user_education.description);
                $educationModal.find("select[name='startDateMonth']").val($data.data.user_education.start_month);
                $educationModal.find("select[name='startDateYear']").val($data.data.user_education.start_year);
                $educationModal.find("select[name='endDateMonth']").val($data.data.user_education.end_month);
                $educationModal.find("select[name='endDateYear']").val($data.data.user_education.end_year);
                $educationModal.find("input[name='presentStudy']").prop('checked', $data.data.user_education.present_study == 1);
                nurseslounge_myDashboard_myProfile.education_validate(function($form){
                    nurseslounge_myDashboard_myProfile.education_request($.extend({}, {action:'set'}, {id:$id}, $params, libs.getObjForm($form)), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $educationModal.modal('hide');
                        });
                    });
                });
                $educationModal.find('.delete-education').unbind().click(function(){
                    nurseslounge_myDashboard_myProfile.education_request($.extend({}, {action:'delete'}, {id:$id}, $params), function(){
                        libs.refreshBoxFrom('.box-profile', null, function(){
                            nurseslounge_myDashboard_myProfile.profile($params);
                            $educationModal.modal('hide');
                        });
                    });
                });
                $educationModal.modal('show');
            });
        });
        $education.find('.add-education').unbind().click(function(){
            $educationModal.find('form')[0].reset();
            $educationModal.find('.delete-education').hide();
            $educationModal.find('.save-education').html('Create');
            nurseslounge_myDashboard_myProfile.education_validate(function($form){
                nurseslounge_myDashboard_myProfile.education_request($.extend({}, {action:'create'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $educationModal.modal('hide');
                    });
                });
            });
            $educationModal.modal('show');
        });
        $education.find('.add-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_myDashboard_myProfile.lounge_review_get_request($params, function($data){
                var $typeId = $data.data.lounge.lounge_type_id;
                var $link = $data.data.lounge.link;
                nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                    router.navigate($link+'/ratingReviews',true);
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                });
            });
        });
        $education.find('.edit-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            $params = $.extend({}, $params, {key:$key});
            nurseslounge_myDashboard_myProfile.lounge_review_get_request($params, function($data){
                var $typeId = $data.data.lounge.lounge_type_id;
                var $link = $data.data.lounge.link;
                nurseslounge_lounge_overview.information_review($typeId, $params, $data, function(){
                    $("#nurseslounge-lounge-information-review-modal").modal('hide');
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                    });
                });
            });
        });
        $education.find('.delete-review').unbind().click(function(){
            var $that = $(this);
            var $key = $that.data('key');
            $params = $.extend({}, $params, {key:$key});
            if(confirm('Are you sure you want to delete your review?')){
                nurseslounge_lounge_overview.information_remove_review($params, function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                    });
                });
            }
        });
    },
    education_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-education-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $.validator.addMethod("compareEducationDates",
            function($val, $ele, $param) {
                var $sYear = $("#home-my-profile-left-profile-education-modal form select[name='startDateYear']").val();
                var $sMonth = $("#home-my-profile-left-profile-education-modal form select[name='startDateMonth']").val();
                var $eYear = $("#home-my-profile-left-profile-education-modal form select[name='endDateYear']").val();
                var $eMonth = $("#home-my-profile-left-profile-education-modal form select[name='endDateMonth']").val();
                if(
                    $sYear != '' && $sMonth != '' && $eYear!= '' && $eMonth!='' &&
                    !$("#home-my-profile-left-profile-education-modal form input[name='presentStudy']").is(':checked')
                ){
                    return parseInt(new Date($sYear, $sMonth).getTime()) < parseInt(new Date($eYear, $eMonth).getTime());
                }else{
                    return true;
                }
            },'Dates error {0}.');
        $validator = $("#home-my-profile-left-profile-education-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                schoolName: {
                    required: true
                },
                degreeName: {
                    required: true
                },
                location: {
                    required: true
                },
                description: {
                    required: false
                },
                startDateMonth: {
                    required: true,
                    compareEducationDates:true
                },
                startDateYear: {
                    required: true,
                    compareEducationDates:true
                },
                endDateMonth: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-education-modal form input[name='presentStudy']").is(':checked')
                    },
                    compareEducationDates:true
                },
                endDateYear: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-education-modal form input[name='presentStudy']").is(':checked')
                    },
                    compareEducationDates:true
                },
            },
            messages: {
                schoolName: {
                    required: "School name is required"
                },
                degreeName: {
                    required: "Degree name is required"
                },
                location: {
                    required: "Location is required"
                },
                description: {
                    required: "Description is not required"
                },
                startDateMonth: {
                    required: "Start month is required",
                    compareEducationDates: "Start date is higher than end date"
                },
                startDateYear: {
                    required: "Start year is required",
                    compareEducationDates: "Start date is higher than end date"
                },
                endDateMonth: {
                    required: "End month is required",
                    compareEducationDates: "End date is lower than start date"
                },
                endDateYear: {
                    required: "End year is required",
                    compareEducationDates: "End date is lower than start date"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-education-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-education-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-education-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    education_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/education/getSet",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    if($data.data.msg != ''){
                        if(window.location.pathname == '/myDashboard/myProfile') {
                            nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                    }
                    cback($data);
                }
            }
        });
    },
    license:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $license = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-license:first');
        var $licenseModal = $('#home-my-profile-left-profile-license-modal');
        $license.find('.edit-license').unbind().click(function(){
            var $id = $(this).data('id');
            nurseslounge_myDashboard_myProfile.license_catalog_request($params, function($data){
                var $chtml = '';
                $chtml+='<option value="">State</option>';
                $.each($data.data.states, function($i, $v){
                    $chtml+='<option value="'+$i+'">'+$v+'</option>';
                });
                $licenseModal.find("select[name='stateId']").html($chtml).promise().done(function(){
                    $licenseModal.find('.delete-license').show();
                    $licenseModal.find('.save-license').html('Save');
                    nurseslounge_myDashboard_myProfile.license_request($.extend({}, {action:'get'}, {id:$id},  $params), function($data){
                        $licenseModal.find("select[name='stateId']").val($data.data.user_license.state.id);
                        $licenseModal.find("select[name='startDateMonth']").val($data.data.user_license.start_month);
                        $licenseModal.find("select[name='startDateYear']").val($data.data.user_license.start_year);
                        $licenseModal.find("select[name='endDateMonth']").val($data.data.user_license.end_month);
                        $licenseModal.find("select[name='endDateYear']").val($data.data.user_license.end_year);
                        nurseslounge_myDashboard_myProfile.license_validate(function($form){
                            nurseslounge_myDashboard_myProfile.license_request($.extend({}, {action:'set'}, {id:$id}, $params, libs.getObjForm($form)), function(){
                                libs.refreshBoxFrom('.box-profile', null, function(){
                                    nurseslounge_myDashboard_myProfile.profile($params);
                                    $licenseModal.modal('hide');
                                });
                            });
                        });
                        $licenseModal.find('.delete-license').unbind().click(function(){
                            nurseslounge_myDashboard_myProfile.license_request($.extend({}, {action:'delete'}, {id:$id}, $params), function(){
                                libs.refreshBoxFrom('.box-profile', null, function(){
                                    nurseslounge_myDashboard_myProfile.profile($params);
                                    $licenseModal.modal('hide');
                                });
                            });
                        });
                        $licenseModal.modal('show');
                    });
                });
            });
        });
        $license.find('.add-license').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.license_catalog_request($params, function($data){
                var $chtml = '';
                $chtml+='<option value="">State</option>';
                $.each($data.data.states, function($i, $v){
                    $chtml+='<option value="'+$i+'">'+$v+'</option>';
                });
                $licenseModal.find("select[name='stateId']").html($chtml).promise().done(function() {
                    $licenseModal.find('form')[0].reset();
                    $licenseModal.find('.delete-license').hide();
                    $licenseModal.find('.save-license').html('Create');
                    nurseslounge_myDashboard_myProfile.license_validate(function($form){
                        nurseslounge_myDashboard_myProfile.license_request($.extend({}, {action:'create'}, $params, libs.getObjForm($form)), function(){
                            libs.refreshBoxFrom('.box-profile', null, function(){
                                nurseslounge_myDashboard_myProfile.profile($params);
                                $licenseModal.modal('hide');
                            });
                        });
                    });
                    $licenseModal.modal('show');
                });
            });
        });

    },
    license_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-license-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $.validator.addMethod("compareLicenseDates",
            function($val, $ele, $param) {
                var $sYear = $("#home-my-profile-left-profile-license-modal form select[name='startDateYear']").val();
                var $sMonth = $("#home-my-profile-left-profile-license-modal form select[name='startDateMonth']").val();
                var $eYear = $("#home-my-profile-left-profile-license-modal form select[name='endDateYear']").val();
                var $eMonth = $("#home-my-profile-left-profile-license-modal form select[name='endDateMonth']").val();
                return parseInt(new Date($sYear, $sMonth).getTime()) < parseInt(new Date($eYear, $eMonth).getTime());
            },'Dates error {0}.');
        $validator = $("#home-my-profile-left-profile-license-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                state: {
                    required: true
                },
                startDateMonth: {
                    required: true,
                    compareLicenseDates:true
                },
                startDateYear: {
                    required: true,
                    compareLicenseDates:true
                },
                endDateMonth: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-license-modal form input[name='currentlyAttending']").is(':checked')
                    },
                    compareLicenseDates:true
                },
                endDateYear: {
                    required: function(){
                        return !$("#home-my-profile-left-profile-license-modal form input[name='currentlyAttending']").is(':checked')
                    },
                    compareLicenseDates:true
                },
            },
            messages: {
                state: {
                    required: "State is required"
                },
                startDateMonth: {
                    required: "Start month is required",
                    compareLicenseDates: "Start date is higher than end date"
                },
                startDateYear: {
                    required: "Start year is required",
                    compareLicenseDates: "Start date is higher than end date"
                },
                endDateMonth: {
                    required: "End month is required",
                    compareLicenseDates: "End date is lower than start date"
                },
                endDateYear: {
                    required: "End year is required",
                    compareLicenseDates: "End date is lower than start date"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-license-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-license-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-license-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    license_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/license/getSet",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback($data);
                }
            }
        });
    },
    license_catalog_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/licenseCatalog/get",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback($data);
                }
            }
        });
    },
    certification:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $certification = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-certification:first');
        $certification.find('.edit-certification:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.certification_open($params);
        });
    },
    certification_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-certification-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-certification-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                certification: {
                    required: true
                }
            },
            messages: {
                certification: {
                    required: "Licenses & Certifications is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-certification-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-certification-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-certification-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    certification_open:function($params){
        var $certificationModal = $('#home-my-profile-left-profile-certification-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'certification'}, {action:'get'}, $params), function($data){
            $certificationModal.find("textarea[name='certification']").val($data.data.certification);
            nurseslounge_myDashboard_myProfile.certification_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'certification'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $certificationModal.modal('hide');
                    });
                });
            });
            $certificationModal.find('.delete-certification:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'certification'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $certificationModal.modal('hide');
                    });
                });
            });
            $certificationModal.modal('show');
        });
    },
    memberships:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $memberships = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-memberships:first');
        $memberships.find('.edit-memberships:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.memberships_open($params);
        });
    },
    memberships_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-memberships-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-memberships-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                memberships: {
                    required: true
                }
            },
            messages: {
                memberships: {
                    required: "Memberships is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-memberships-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-memberships-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-memberships-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    memberships_open:function($params){
        var $membershipsModal = $('#home-my-profile-left-profile-memberships-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'memberships'}, {action:'get'}, $params), function($data){
            $membershipsModal.find("textarea[name='memberships']").val($data.data.memberships);
            nurseslounge_myDashboard_myProfile.memberships_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'memberships'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $membershipsModal.modal('hide');
                    });
                });
            });
            $membershipsModal.find('.delete-memberships:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'memberships'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $membershipsModal.modal('hide');
                    });
                });
            });
            $membershipsModal.modal('show');
        });
    },
    volunteer:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $volunteer = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-volunteer:first');
        $volunteer.find('.edit-volunteer:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.volunteer_open($params);
        });
    },
    volunteer_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-volunteer-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-volunteer-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                volunteer: {
                    required: true
                }
            },
            messages: {
                volunteer: {
                    required: "Volunteer is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-volunteer-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-volunteer-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-volunteer-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    volunteer_open:function($params){
        var $volunteerModal = $('#home-my-profile-left-profile-volunteer-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'volunteer'}, {action:'get'}, $params), function($data){
            $volunteerModal.find("textarea[name='volunteer']").val($data.data.volunteer);
            nurseslounge_myDashboard_myProfile.volunteer_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'volunteer'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $volunteerModal.modal('hide');
                    });
                });
            });
            $volunteerModal.find('.delete-volunteer:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'volunteer'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $volunteerModal.modal('hide');
                    });
                });
            });
            $volunteerModal.modal('show');
        });
    },
    research:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $research = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-research:first');
        $research.find('.edit-research:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.research_open($params);
        });
    },
    research_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-research-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-research-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                research: {
                    required: true
                }
            },
            messages: {
                research: {
                    required: "Research is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-research-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-research-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-research-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    research_open:function($params){
        var $researchModal = $('#home-my-profile-left-profile-research-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'research'}, {action:'get'}, $params), function($data){
            $researchModal.find("textarea[name='research']").val($data.data.research);
            nurseslounge_myDashboard_myProfile.research_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'research'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $researchModal.modal('hide');
                    });
                });
            });
            $researchModal.find('.delete-research:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'research'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $researchModal.modal('hide');
                    });
                });
            });
            $researchModal.modal('show');
        });
    },
    publications:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $publications = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-publications:first');
        $publications.find('.edit-publications:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.publications_open($params);
        });
    },
    publications_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-publications-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-publications-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                publications: {
                    required: true
                }
            },
            messages: {
                publications: {
                    required: "Publications is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-publications-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-publications-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-publications-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    publications_open:function($params){
        var $publicationsModal = $('#home-my-profile-left-profile-publications-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'publications'}, {action:'get'}, $params), function($data){
            $publicationsModal.find("textarea[name='publications']").val($data.data.publications);
            nurseslounge_myDashboard_myProfile.publications_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'publications'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $publicationsModal.modal('hide');
                    });
                });
            });
            $publicationsModal.find('.delete-publications:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'publications'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $publicationsModal.modal('hide');
                    });
                });
            });
            $publicationsModal.modal('show');
        });
    },
    presentations:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $presentations = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-presentations:first');
        $presentations.find('.edit-presentations:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.presentations_open($params);
        });
    },
    presentations_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-presentations-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-presentations-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                presentations: {
                    required: true
                }
            },
            messages: {
                presentations: {
                    required: "Presentations is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-presentations-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-presentations-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-presentations-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    presentations_open:function($params){
        var $presentationsModal = $('#home-my-profile-left-profile-presentations-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'presentations'}, {action:'get'}, $params), function($data){
            $presentationsModal.find("textarea[name='presentations']").val($data.data.presentations);
            nurseslounge_myDashboard_myProfile.presentations_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'presentations'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $presentationsModal.modal('hide');
                    });
                });
            });
            $presentationsModal.find('.delete-presentations:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'presentations'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $presentationsModal.modal('hide');
                    });
                });
            });
            $presentationsModal.modal('show');
        });
    },
    awards:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $awards = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-awards:first');
        $awards.find('.edit-awards:first').unbind().click(function(){
            nurseslounge_myDashboard_myProfile.awards_open($params);
        });
    },
    awards_validate:function(cback){
        var $validator;
        try {
            $validator = $("#home-my-profile-left-profile-awards-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#home-my-profile-left-profile-awards-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                awards: {
                    required: true
                }
            },
            messages: {
                awards: {
                    required: "Awards is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
        $("#home-my-profile-left-profile-awards-modal form").find('.invalid-feedback').hide();
        $("#home-my-profile-left-profile-awards-modal form").find('.error').removeClass('error');
        $("#home-my-profile-left-profile-awards-modal form").find('.is-invalid').removeClass('is-invalid');
    },
    awards_open:function($params){
        var $awardsModal = $('#home-my-profile-left-profile-awards-modal');
        nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'awards'}, {action:'get'}, $params), function($data){
            $awardsModal.find("textarea[name='awards']").val($data.data.awards);
            nurseslounge_myDashboard_myProfile.awards_validate(function($form){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'awards'}, {action:'set'}, $params, libs.getObjForm($form)), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $awardsModal.modal('hide');
                    });
                });
            });
            $awardsModal.find('.delete-awards:first').unbind().click(function(){
                nurseslounge_myDashboard_myProfile.info_request($.extend({}, {type:'awards'}, {action:'delete'}, $params), function(){
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile($params);
                        $awardsModal.modal('hide');
                    });
                });
            });
            $awardsModal.modal('show');
        });
    },
    info_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/info/getSet",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback($data);
                }
            }
        });
    },
    add_cards:function($params){
        var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
        var $cards = $profileLeft.find('.home-my-profile-left-profile-add-cards:first');
        $cards.find('.add-cards:first').unbind().change(function(){
            var $section = $(this).val();
            if($section != ''){
                switch ($section) {
                    case 'certification':
                        nurseslounge_myDashboard_myProfile.certification_open($params);
                        break;
                    case 'memberships':
                        nurseslounge_myDashboard_myProfile.memberships_open($params);
                        break;
                    case 'volunteer':
                        nurseslounge_myDashboard_myProfile.volunteer_open($params);
                        break;
                    case 'research':
                        nurseslounge_myDashboard_myProfile.research_open($params);
                        break;
                    case 'publications':
                        nurseslounge_myDashboard_myProfile.publications_open($params);
                        break;
                    case 'presentations':
                        nurseslounge_myDashboard_myProfile.presentations_open($params);
                        break;
                    case 'awards':
                        nurseslounge_myDashboard_myProfile.awards_open($params);
                        break;
                }
            }
            $(this).val('');
        });
    },
    //User Profile Settings
    user_profile_fill:function($params, $isDashboardSetting){
        if($isDashboardSetting){
            if(!$("#nurseslounge-home-my-profile-edit-modal .state").hasClass('col-sm-6')){
                $("#nurseslounge-home-my-profile-edit-modal .state").addClass('col-sm-6').removeClass('col-sm-12');
            }
            $("#nurseslounge-home-my-profile-edit-modal .profile-type").show();
            $("#nurseslounge-home-my-profile-edit-modal .city").show();
            $("#nurseslounge-home-my-profile-edit-modal .state").show();
            $("#nurseslounge-home-my-profile-edit-modal .email-address").show();
            $("#nurseslounge-home-my-profile-edit-modal .postal-code").show();
            $("#nurseslounge-home-my-profile-edit-modal .change-password").show();
            $("#nurseslounge-home-my-profile-edit-modal .first-name").hide();
            $("#nurseslounge-home-my-profile-edit-modal .last-name").hide();
        }else{
            if($("#nurseslounge-home-my-profile-edit-modal .state").hasClass('col-sm-6')){
                $("#nurseslounge-home-my-profile-edit-modal .state").removeClass('col-sm-6').addClass('col-sm-12');
            }
            $("#nurseslounge-home-my-profile-edit-modal .profile-type").hide();
            $("#nurseslounge-home-my-profile-edit-modal .city").hide();
            $("#nurseslounge-home-my-profile-edit-modal .state").show();
            $("#nurseslounge-home-my-profile-edit-modal .email-address").hide();
            $("#nurseslounge-home-my-profile-edit-modal .postal-code").hide();
            $("#nurseslounge-home-my-profile-edit-modal .change-password").hide();
            $("#nurseslounge-home-my-profile-edit-modal .first-name").show();
            $("#nurseslounge-home-my-profile-edit-modal .last-name").show();
        }
        $.ajax({
            url: "/myDashboard/myProfile/permissions/droplists",
            method: "POST",
            cache:false,
            dataType: "json",
            success: function ($data) {
                libs.expire($data);
                if($data.status == 'success'){
                    var $catalog = $data;
                    var $inputAutocomplete = $("#nurseslounge-home-my-profile-edit-modal form input[name='city']")[0];
                    new google.maps.places.Autocomplete($inputAutocomplete, {
                        types: ['(regions)'],
                        componentRestrictions: {country: "us"}
                    });
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='state']").html($data.data.state);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='profile']").html($data.data.profile);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingRecruiterEmployerType']").html($data.data.nursingRecruiterEmployerType);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='organizationRepresentativeOrganizationType']").html($data.data.organizationRepresentativeOrganizationType);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentDegreeType']").html($data.data.nursingStudentDegreeType);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentMonth']").html($data.data.nursingStudentMonth);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentYear']").html($data.data.nursingStudentYear);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseNursingDegrees']").html($data.data.nurseNursingDegrees);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyNursingDegrees']").html($data.data.nurseFacultyNursingDegrees);
                    var $nurseFacultySpecialty = '<optgroup label=""><option value="Any">Does Not Apply</option></optgroup>';
                    $nurseFacultySpecialty = $nurseFacultySpecialty+$data.data.nurseFacultySpecialty;
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultySpecialty']").html($nurseFacultySpecialty);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseYearsOfExperience']").html($data.data.nurseYearsOfExperience);
                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyYearsOfExperience']").html($data.data.nurseFacultyYearsOfExperience);
                    $.ajax({
                        url: "/myDashboard/myProfile/permissions/fill",
                        method: "POST",
                        cache:false,
                        data:$params,
                        dataType: "json",
                        success: function ($data) {
                            libs.expire($data);
                            if($data.status == 'success') {
                                $("#nurseslounge-home-my-profile-edit-modal form input[name='firstName']").val($data.data.first_name);
                                $("#nurseslounge-home-my-profile-edit-modal form input[name='lastName']").val($data.data.last_name);
                                $("#nurseslounge-home-my-profile-edit-modal form input[name='email']").val($data.data.email);
                                $("#nurseslounge-home-my-profile-edit-modal form select[name='systemProfile']").val($data.data.administrator_profile_id);
                                $("#nurseslounge-home-my-profile-edit-modal form select[name='state']").val($data.data.state_id);
                                $("#nurseslounge-home-my-profile-edit-modal form input[name='city']").val($data.data.city);
                                $("#nurseslounge-home-my-profile-edit-modal form input[name='zipCode']").val($data.data.zip_code);
                                $("#nurseslounge-home-my-profile-edit-modal form select[name='profile']").val($data.data.profile_id).unbind().change(function(){
                                    var $profile = $(this).val();

                                    $("#nurseslounge-home-my-profile-edit-modal form .nursing-recruiter").hide();
                                    $("#nurseslounge-home-my-profile-edit-modal form .organization-representative").hide();
                                    $("#nurseslounge-home-my-profile-edit-modal form .nursing-student").hide();
                                    $("#nurseslounge-home-my-profile-edit-modal form .nurse").hide();
                                    $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty").hide();

                                    $params = $.extend({}, $params, $data.data);


                                    var $nurseSpecialty = '<optgroup label=""><option value="Any">Does Not Apply</option></optgroup>';
                                    if($profile == 6){
                                        $nurseSpecialty = $nurseSpecialty+$catalog.data.advanceSpecialty;
                                    }else{
                                        $nurseSpecialty = $nurseSpecialty+$catalog.data.nurseSpecialty;
                                    }
                                    $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseSpecialty']").html($nurseSpecialty);

                                    if($profile == 1){
                                        nurseslounge_myDashboard_myProfile.user_profile_recruiter_edit_events($params, $isDashboardSetting);
                                    }else
                                    if($profile == 2){
                                        nurseslounge_myDashboard_myProfile.user_profile_organization_representative_edit_events($params, $isDashboardSetting);
                                    }else
                                    if($profile == 3 || $profile == 7){
                                        nurseslounge_myDashboard_myProfile.user_profile_nursing_student_edit_events($params, $isDashboardSetting, $profile);
                                    }else
                                    if($profile == 4 || $profile == 6){
                                        nurseslounge_myDashboard_myProfile.user_profile_nurse_edit_events($params, $isDashboardSetting, $profile);
                                    }else
                                    if($profile == 5){
                                        nurseslounge_myDashboard_myProfile.user_profile_nurse_faculty_edit_events($params, $isDashboardSetting);
                                    }
                                });

                                $("#nurseslounge-home-my-profile-edit-modal form .nursing-recruiter").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .organization-representative").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .nursing-student").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .nurse").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty").hide();

                                var $profile = $data.data.profile_id;

                                $params = $.extend({}, $params, $data.data);

                                var $nurseSpecialty = '<optgroup label=""><option value="Any">Does Not Apply</option></optgroup>';
                                if($profile == 6){
                                    $nurseSpecialty = $nurseSpecialty+$catalog.data.advanceSpecialty;
                                }else{
                                    $nurseSpecialty = $nurseSpecialty+$catalog.data.nurseSpecialty;
                                }
                                $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseSpecialty']").html($nurseSpecialty);

                                if($profile == 1){
                                    nurseslounge_myDashboard_myProfile.user_profile_recruiter_edit_events($params, $isDashboardSetting);
                                }else
                                if($profile == 2){
                                    nurseslounge_myDashboard_myProfile.user_profile_organization_representative_edit_events($params, $isDashboardSetting);
                                }else
                                if($profile == 3 || $profile == 7){
                                    nurseslounge_myDashboard_myProfile.user_profile_nursing_student_edit_events($params, $isDashboardSetting, $profile);
                                }else
                                if($profile == 4 || $profile == 6){
                                    nurseslounge_myDashboard_myProfile.user_profile_nurse_edit_events($params, $isDashboardSetting, $profile);
                                }else
                                if($profile == 5){
                                    nurseslounge_myDashboard_myProfile.user_profile_nurse_faculty_edit_events($params, $isDashboardSetting);
                                }
                            }
                            $("#nurseslounge-home-my-profile-edit-modal").on('hidden.bs.modal', function () {
                                $("#nurseslounge-home-my-profile-edit-modal form")[0].reset();
                                $("#nurseslounge-home-my-profile-edit-modal form .nursing-recruiter").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .organization-representative").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .nursing-student").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .nurse").hide();
                                $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty").hide();
                            }).modal('show');
                        }
                    });
                }
            }
        });
    },
    user_profile_recruiter_edit_events:function($params, $isDashboardSetting){

        if(!$isDashboardSetting){
            $("#nurseslounge-home-my-profile-edit-modal .nursing-recruiter-employer").hide();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .nursing-recruiter-employer").show();
        }

        nurseslounge_myDashboard_myProfile.user_profile_recruiter_validate($params, function($form){
            nurseslounge_myDashboard_myProfile.user_profile_edit_request($.extend({}, $params, {id:$params.id},libs.getObjForm($form)));
        });

        $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingRecruiterEmployerType']").val($params.employer_type_id);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nursingRecruiterEmployerName']").val($params.nursingRecruiterEmployerName.join(','));
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nursingRecruiterJobTitle']").val($params.job_title);

        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='nursingRecruiterEmployerName']",
            null,
            "/signup/nursing/recruiter/employer/type",
            1,
            $.extend({}, $params, {type:['employers']})
        );
        //nurseslounge_myDashboard_myProfile.multiple_autocomplete("#nurseslounge-home-my-profile-edit-modal form","input[name='nursingRecruiterEmployerName']","/signup/nursing/recruiter/employer/type");
        //nurseslounge_myDashboard_myProfile.general_autocomplete("#nurseslounge-home-my-profile-edit-modal form","input[name='nursingRecruiterJobTitle']","input[name='nursingRecruiterJobTitleID']","/signup/nursing/recruiter/job/title", 1);

        $("#nurseslounge-home-my-profile-edit-modal form .nursing-recruiter").show();
        $("#nurseslounge-home-my-profile-edit-modal .specialty").show();
    },
    user_profile_recruiter_validate:function($params, cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                password: {
                    required: false,
                    minlength: 8,
                    maxlength: 191
                },
                retypePassword: {
                    required: false,
                    equalTo: "#nurseslounge-home-my-profile-edit-modal form input[name='password']"
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                email: {
                    required: function(){
                        var $form = $("#nurseslounge-home-my-profile-edit-modal form");
                        return $form.find(".change-password").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){
                                return $("#nurseslounge-home-my-profile-edit-modal form input[name='email']").val();
                            },
                            emailSaved: $params.email
                        }
                    }
                },
                state: {
                    required: true
                },
                city: {
                    required: false
                },
                zipCode: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .postal-code").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191
                },
                profile: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .profile-type").is(':visible');
                    }
                },
                nursingRecruiterEmployerType: {
                    required: false
                },
                nursingRecruiterEmployerName: {
                    required: false
                },
                nursingRecruiterJobTitle: {
                    required: false
                }
            },
            messages: {
                password: {
                    required: "The new password is not required",
                    minlength: "The new password must have at least 8 characters",
                    maxlength: "The new password cannot exceed 191 characters"
                },
                retypePassword: {
                    required: "The retype password is not required",
                    equalTo: "The retype password must be identical"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                state: {
                    required: "The state is required"
                },
                city: {
                    required: "The city is not required"
                },
                zipCode: {
                    required: "The zip code is required",
                    minlength: "The zip code must have at least 3 characters",
                    maxlength: "The zip code cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                },
                nursingRecruiterEmployerType: {
                    required: "The employer type is not required"
                },
                nursingRecruiterEmployerName: {
                    required: "The employer name is not required"
                },
                nursingRecruiterJobTitle: {
                    required: "The job title is not required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    user_profile_organization_representative_edit_events:function($params, $isDashboardSetting){

        if(!$isDashboardSetting){
            $("#nurseslounge-home-my-profile-edit-modal .organization-representative-type").hide();
            $("#nurseslounge-home-my-profile-edit-modal .organization-representative-organization").hide();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .organization-representative-type").show();
            $("#nurseslounge-home-my-profile-edit-modal .organization-representative-organization").show();
        }

        nurseslounge_myDashboard_myProfile.user_profile_organization_representative_validate($params, function($form){
            nurseslounge_myDashboard_myProfile.user_profile_edit_request($.extend({}, $params, {id:$params.id},libs.getObjForm($form)));
        });

        $("#nurseslounge-home-my-profile-edit-modal form select[name='organizationRepresentativeOrganizationType']").val($params.organization_type_id);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='organizationRepresentativeOrganization']").val($params.organizationRepresentativeOrganization.join(','));
        $("#nurseslounge-home-my-profile-edit-modal form input[name='organizationRepresentativeJobTitle']").val($params.job_title);

        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='organizationRepresentativeOrganization']",
            null,
            "/signup/nursing/recruiter/employer/type",
            1,
            $.extend({}, $params, {type:['employers', 'schools']})
        );
        //nurseslounge_myDashboard_myProfile.general_autocomplete("#nurseslounge-home-my-profile-edit-modal form","input[name='organizationRepresentativeJobTitle']","input[name='organizationRepresentativeJobTitleID']","/signup/organization/representative/job/title", 1);

        $("#nurseslounge-home-my-profile-edit-modal form .organization-representative").show();
        $("#nurseslounge-home-my-profile-edit-modal .specialty").show();
    },
    user_profile_organization_representative_validate:function($params, cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                password: {
                    required: false,
                    minlength: 8,
                    maxlength: 191
                },
                retypePassword: {
                    required: false,
                    equalTo: "#nurseslounge-home-my-profile-edit-modal form input[name='password']"
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                email: {
                    required: function(){
                        var $form = $("#nurseslounge-home-my-profile-edit-modal form");
                        return $form.find(".change-password").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){
                                return $("#nurseslounge-home-my-profile-edit-modal form input[name='email']").val();
                            },
                            emailSaved: $params.email
                        }
                    }
                },
                state: {
                    required: true
                },
                city: {
                    required: false
                },
                zipCode: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .postal-code").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191
                },
                profile: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .profile-type").is(':visible');
                    }
                },
                organizationRepresentativeOrganizationType: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .organization-representative-type").is(':visible');
                    }
                },
                organizationRepresentativeOrganization: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .organization-representative-organization").is(':visible');
                    }
                },
                organizationRepresentativeJobTitle: {
                    required: false
                }
            },
            messages: {
                password: {
                    required: "The new password is not required",
                    minlength: "The new password must have at least 8 characters",
                    maxlength: "The new password cannot exceed 191 characters"
                },
                retypePassword: {
                    required: "The retype password is not required",
                    equalTo: "The retype password must be identical"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                state: {
                    required: "The state is required"
                },
                city: {
                    required: "The city is not required"
                },
                zipCode: {
                    required: "The zip code is required",
                    minlength: "The zip code must have at least 3 characters",
                    maxlength: "The zip code cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                },
                organizationRepresentativeOrganizationType: {
                    required: "The organization type is required"
                },
                organizationRepresentativeOrganization: {
                    required: "The organization is required"
                },
                organizationRepresentativeJobTitle: {
                    required: "The job title is not required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                cback($form);
                return false;
            }
        });
    },
    user_profile_nursing_student_edit_events:function($params, $isDashboardSetting, $profile){
        var $additionalDegreesInput = $("#nurseslounge-home-my-profile-edit-modal input[name='nursingStudentAdditionalDegrees']");
        var $tagifyTags = libs.memoryGet('nurseslounge_myDashboard_myProfile_nursing_student_additional_degrees');
        if($tagifyTags){
            try{
                $tagifyTags.DOM.input.classList.remove('tagify__input--outside');
                $tagifyTags.DOM.input.classList.remove('tagify__input');
                $tagifyTags.removeAllTags();
                $tagifyTags.destroy();
            }catch ($e) {

            }
        }
        if($profile == 7) {
            $tagifyTags = new Tagify($additionalDegreesInput[0]);
            $tagifyTags.DOM.input.classList.add('tagify__input--outside');
            $tagifyTags.DOM.scope.parentNode.insertBefore($tagifyTags.DOM.input, $tagifyTags.DOM.scope);
            var $designationLevel = $params.designation_level;
            $designationLevel = $designationLevel.filter(function($designation){
                return $designation.profile_id == $profile
            });
            for (var $i in $designationLevel) {
                $tagifyTags.addTags($designationLevel[$i].designation);
            }
            libs.memorySave('nurseslounge_myDashboard_myProfile_nursing_student_additional_degrees', $tagifyTags);
            $("#nurseslounge-home-my-profile-edit-modal .nursing-student-additional-degrees").show();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .nursing-student-additional-degrees").hide();
        }
        if(!$isDashboardSetting){
            $("#nurseslounge-home-my-profile-edit-modal .nursing-student-degree").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nursing-student-school").hide();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .nursing-student-degree").show();
            $("#nurseslounge-home-my-profile-edit-modal .nursing-student-school").show();
        }

        nurseslounge_myDashboard_myProfile.user_profile_nursing_student_validate($params, function($form){
            var $additionalDegrees = [];
            var $additionalDegreesVal = $additionalDegreesInput.val();
            if($additionalDegreesVal != '') {
                var $selectedTags = JSON.parse($additionalDegreesVal);
                for (var $i in $selectedTags) {
                    $additionalDegrees.push($selectedTags[$i].value);
                }
            }
            $params = $.extend({}, $params, {additionalDegrees:$additionalDegrees});
            nurseslounge_myDashboard_myProfile.user_profile_edit_request($.extend({}, $params, {id:$params.id},libs.getObjForm($form)));
        });

        $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentDegreeType']").val($params.nursingStudentDegreeType);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nursingStudentSchoolAttended']").val($params.nursingStudentSchoolAttended);
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentMonth']").val($params.month);
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentYear']").val($params.year);

        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='nursingStudentSchoolAttended']",
            null,
            "/signup/nursing/recruiter/employer/type",
            1,
            $.extend({}, $params, {type:['schools']})
        );

        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentDegreeType']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentDegreeType']").chosen();

        $("#nurseslounge-home-my-profile-edit-modal form .nursing-student").show();
        $("#nurseslounge-home-my-profile-edit-modal .specialty").hide();

    },
    user_profile_nursing_student_validate:function($params, cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                password: {
                    required: false,
                    minlength: 8,
                    maxlength: 191
                },
                retypePassword: {
                    required: false,
                    equalTo: "#nurseslounge-home-my-profile-edit-modal form input[name='password']"
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                email: {
                    required: function(){
                        var $form = $("#nurseslounge-home-my-profile-edit-modal form");
                        return $form.find(".change-password").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){
                                return $("#nurseslounge-home-my-profile-edit-modal form input[name='email']").val();
                            },
                            emailSaved: $params.email
                        }
                    }
                },
                state: {
                    required: true
                },
                city: {
                    required: false
                },
                zipCode: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .postal-code").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191
                },
                profile: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .profile-type").is(':visible');
                    }
                },
                nursingStudentDegreeType: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nursing-student-degree").is(':visible');
                    }
                },
                nursingStudentSchoolAttended: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nursing-student-school").is(':visible');
                    }
                },
                nursingStudentMonth: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nursing-student-expected-graduation").is(':visible');
                    }
                },
                nursingStudentYear: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nursing-student-expected-graduation").is(':visible');
                    }
                }
            },
            messages: {
                password: {
                    required: "The new password is not required",
                    minlength: "The new password must have at least 8 characters",
                    maxlength: "The new password cannot exceed 191 characters"
                },
                retypePassword: {
                    required: "The retype password is not required",
                    equalTo: "The retype password must be identical"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                state: {
                    required: "The state is required"
                },
                city: {
                    required: "The city is not required"
                },
                zipCode: {
                    required: "The zip code is required",
                    minlength: "The zip code must have at least 3 characters",
                    maxlength: "The zip code cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                },
                nursingStudentDegreeType: {
                    required: "The degree type is required"
                },
                nursingStudentSchoolAttended: {
                    required: "The school name is required"
                },
                nursingStudentMonth: {
                    required: "The month is required"
                },
                nursingStudentYear: {
                    required: "The year is required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                if($("#nurseslounge-home-my-profile-edit-modal form select[name='nursingStudentDegreeType']").val() == null){
                    $validator.showErrors({ nursingStudentDegreeType: "The degree type is required" });
                    return false;
                }
                cback($form);
                return false;
            }
        });
    },
    user_profile_nurse_edit_events:function($params, $isDashboardSetting, $profile){
        var $additionalDegreesInput = $("#nurseslounge-home-my-profile-edit-modal input[name='nurseAdditionalDegrees']");
        var $tagifyTags = libs.memoryGet('nurseslounge_myDashboard_myProfile_nurse_additional_degrees');
        if($tagifyTags){
            try{
                $tagifyTags.DOM.input.classList.remove('tagify__input--outside');
                $tagifyTags.DOM.input.classList.remove('tagify__input');
                $tagifyTags.removeAllTags();
                $tagifyTags.destroy();
            }catch ($e) {

            }
        }
        if($profile == 6) {
            $tagifyTags = new Tagify($additionalDegreesInput[0]);
            $tagifyTags.DOM.input.classList.add('tagify__input--outside');
            $tagifyTags.DOM.scope.parentNode.insertBefore($tagifyTags.DOM.input, $tagifyTags.DOM.scope);
            var $designationLevel = $params.designation_level;
            $designationLevel = $designationLevel.filter(function($designation){
                return $designation.profile_id == $profile
            });
            for (var $i in $designationLevel) {
                $tagifyTags.addTags($designationLevel[$i].designation);
            }
            libs.memorySave('nurseslounge_myDashboard_myProfile_nurse_additional_degrees', $tagifyTags);
            $("#nurseslounge-home-my-profile-edit-modal .nurse-additional-degrees").show();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .nurse-additional-degrees").hide();
        }
        if(!$isDashboardSetting){
            $("#nurseslounge-home-my-profile-edit-modal .nurse-school-name").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-specialty").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-years-of-experience").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-employer").hide();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .nurse-school-name").show();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-specialty").show();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-years-of-experience").show();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-employer").show();
        }

        nurseslounge_myDashboard_myProfile.user_profile_nurse_validate($params, function($form){
            var $additionalDegrees = [];
            var $additionalDegreesVal = $additionalDegreesInput.val();
            if($additionalDegreesVal != '') {
                var $selectedTags = JSON.parse($additionalDegreesVal);
                for (var $i in $selectedTags) {
                    $additionalDegrees.push($selectedTags[$i].value);
                }
            }
            $params = $.extend({}, $params, {additionalDegrees:$additionalDegrees});
            nurseslounge_myDashboard_myProfile.user_profile_edit_request($.extend({}, $params, {id:$params.id},libs.getObjForm($form)));
        });

        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseNursingDegrees']").val($params.nurseNursingDegrees);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nurseNursingSchoolAttended']").val($params.nurseNursingSchoolAttended.join(','));
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseSpecialty']").val($params.nurseSpecialty);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nurseJobTitle']").val($params.job_title);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nurseEmployer']").val($params.nurseEmployer.join(','));
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseYearsOfExperience']").val($params.nurseYearsOfExperience);

        /*
        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseYearsOfExperience']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseYearsOfExperience']").chosen();
         */

        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseNursingDegrees']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseNursingDegrees']").chosen();

        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseSpecialty']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseSpecialty']").chosen();

        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='nurseNursingSchoolAttended']",
            null,
            "/signup/nursing/recruiter/employer/type",
            1,
            $.extend({}, $params, {type:['schools']})
        );
        //nurseslounge_myDashboard_myProfile.general_autocomplete("#nurseslounge-home-my-profile-edit-modal form","input[name='nurseJobTitle']","input[name='nurseJobTitleID']","/signup/nurse/job/title", 1);
        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='nurseEmployer']",
            null,
            "/signup/nurse/employer",
            1,
            $.extend({}, $params, {type:['employers']})
        );

        $("#nurseslounge-home-my-profile-edit-modal form .nurse").show();
        $("#nurseslounge-home-my-profile-edit-modal .specialty").show();
    },
    user_profile_nurse_validate:function($params, cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                password: {
                    required: false,
                    minlength: 8,
                    maxlength: 191
                },
                retypePassword: {
                    required: false,
                    equalTo: "#nurseslounge-home-my-profile-edit-modal form input[name='password']"
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                email: {
                    required: function(){
                        var $form = $("#nurseslounge-home-my-profile-edit-modal form");
                        return $form.find(".change-password").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){
                                return $("#nurseslounge-home-my-profile-edit-modal form input[name='email']").val();
                            },
                            emailSaved: $params.email
                        }
                    }
                },
                state: {
                    required: true
                },
                city: {
                    required: false
                },
                zipCode: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .postal-code").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191
                },
                profile: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .profile-type").is(':visible');
                    }
                },
                nurseNursingDegrees: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-destination-level").is(':visible');
                    }
                },
                nurseNursingSchoolAttended: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-school-name").is(':visible');
                    }
                },
                nurseSpecialty: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-specialty").is(':visible');
                    }
                },
                nurseYearsOfExperience: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-years-of-experience").is(':visible');
                    }
                },
                nurseJobTitle: {
                    required: false
                },
                nurseEmployer: {
                    required: false
                }
            },
            messages: {
                password: {
                    required: "The new password is not required",
                    minlength: "The new password must have at least 8 characters",
                    maxlength: "The new password cannot exceed 191 characters"
                },
                retypePassword: {
                    required: "The retype password is not required",
                    equalTo: "The retype password must be identical"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                state: {
                    required: "The state is required"
                },
                city: {
                    required: "The city is not required"
                },
                zipCode: {
                    required: "The zip code is required",
                    minlength: "The zip code must have at least 3 characters",
                    maxlength: "The zip code cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                },
                nurseNursingDegrees: {
                    required: "The nursing degrees is required"
                },
                nurseNursingSchoolAttended: {
                    required: "The school name is required"
                },
                nurseSpecialty: {
                    required: "The specialty is required"
                },
                nurseYearsOfExperience: {
                    required: "The year of experience is required"
                },
                nurseJobTitle: {
                    required: "The job title is not required"
                },
                nurseEmployer: {
                    required: "The employer is not required"
                }
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                if($("#nurseslounge-home-my-profile-edit-modal form select[name='nurseNursingDegrees']").val() == null){
                    $validator.showErrors({ nurseNursingDegrees: "The nursing degrees is required" });
                    return false;
                }
                if($("#nurseslounge-home-my-profile-edit-modal form select[name='nurseSpecialty']").val() == null){
                    $validator.showErrors({ nurseSpecialty: "The specialty is required" });
                    return false;
                }
                cback($form);
                return false;
            }
        });
    },
    user_profile_nurse_faculty_edit_events:function($params, $isDashboardSetting){

        if(!$isDashboardSetting){
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-school-name").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-specialty").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-years-of-experience").hide();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-employer").hide();
        }else{
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-school-name").show();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-specialty").show();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-years-of-experience").show();
            $("#nurseslounge-home-my-profile-edit-modal .nurse-faculty-employer").show();
        }

        nurseslounge_myDashboard_myProfile.user_profile_nurse_faculty_validate($params, function($form){
            nurseslounge_myDashboard_myProfile.user_profile_edit_request($.extend({}, $params, {id:$params.id},libs.getObjForm($form)));
        });

        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyNursingDegrees']").val($params.nurseFacultyNursingDegrees);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nurseFacultyNursingSchoolAttended']").val($params.nurseFacultyNursingSchoolAttended.join(','));
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultySpecialty']").val($params.nurseFacultySpecialty);
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyYearsOfExperience']").val($params.nurseFacultyYearsOfExperience);
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nurseFacultyEmployer']").val($params.nurseFacultyEmployer.join(','));
        $("#nurseslounge-home-my-profile-edit-modal form input[name='nurseFacultyJobTitle']").val($params.job_title);

        /*
        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseYearsOfExperience']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseYearsOfExperience']").chosen();
         */

        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyNursingDegrees']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyNursingDegrees']").chosen();

        try{
            $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultySpecialty']").chosen("destroy");
        }catch (e) {}
        $("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultySpecialty']").chosen();

        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='nurseFacultyNursingSchoolAttended']",
            null,
            "/signup/nursing/recruiter/employer/type",
            1,
            $.extend({}, $params, {type:['schools']})
        );
        //nurseslounge_myDashboard_myProfile.general_autocomplete("#nurseslounge-home-my-profile-edit-modal form","input[name='nurseJobTitle']","input[name='nurseJobTitleID']","/signup/nurse/job/title", 1);
        nurseslounge_myDashboard_myProfile.general_autocomplete(
            "#nurseslounge-home-my-profile-edit-modal form",
            "input[name='nurseFacultyEmployer']",
            null,
            "/signup/nursing/recruiter/employer/type",
            1,
            $.extend({}, $params, {type:['schools']})
        );

        $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty").show();
    },
    user_profile_nurse_faculty_validate:function($params, cback){
        var $validator;
        try {
            $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate();
            $validator.destroy();
        }catch (e) {

        }
        $validator = $("#nurseslounge-home-my-profile-edit-modal form").validate({
            onsubmit: true,
            debug: false,
            ignore: "*:not(.validate)",
            rules: {
                password: {
                    required: false,
                    minlength: 8,
                    maxlength: 191
                },
                retypePassword: {
                    required: false,
                    equalTo: "#nurseslounge-home-my-profile-edit-modal form input[name='password']"
                },
                firstName: {
                    required: true,
                    maxlength: 191
                },
                lastName: {
                    required: true,
                    maxlength: 191
                },
                email: {
                    required: function(){
                        var $form = $("#nurseslounge-home-my-profile-edit-modal form");
                        return $form.find(".change-password").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191,
                    email:true,
                    remote: {
                        url: "/signup/email/exist",
                        type: "post",
                        data: {
                            email: function(){
                                return $("#nurseslounge-home-my-profile-edit-modal form input[name='email']").val();
                            },
                            emailSaved: $params.email
                        }
                    }
                },
                state: {
                    required: true
                },
                city: {
                    required: false
                },
                zipCode: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .postal-code").is(':visible');
                    },
                    minlength: 3,
                    maxlength: 191
                },
                profile: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .profile-type").is(':visible');
                    }
                },
                nurseFacultyNursingDegrees: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty-destination-level").is(':visible');
                    }
                },
                nurseFacultyNursingSchoolAttended: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty-school-name").is(':visible');
                    }
                },
                nurseFacultySpecialty: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty-specialty").is(':visible');
                    }
                },
                nurseFacultyYearsOfExperience: {
                    required: function(){
                        return $("#nurseslounge-home-my-profile-edit-modal form .nurse-faculty-years-of-experience").is(':visible');
                    }
                },
                nurseFacultyEmployer: {
                    required: false
                },
                nurseFacultyJobTitle: {
                    required: false
                },
            },
            messages: {
                password: {
                    required: "The new password is not required",
                    minlength: "The new password must have at least 8 characters",
                    maxlength: "The new password cannot exceed 191 characters"
                },
                retypePassword: {
                    required: "The retype password is not required",
                    equalTo: "The retype password must be identical"
                },
                firstName: {
                    required: "The first name is required",
                    maxlength: "The first name cannot exceed 191 characters"
                },
                lastName: {
                    required: "The last name is required",
                    maxlength: "The last name cannot exceed 191 characters"
                },
                email: {
                    required: "The email is required",
                    minlength: "The email must have at least 3 characters",
                    maxlength: "The email cannot exceed 191 characters",
                    email:"The email is invalid",
                    remote:"The email exist, choose another"
                },
                state: {
                    required: "The state is required"
                },
                city: {
                    required: "The city is not required"
                },
                zipCode: {
                    required: "The zip code is required",
                    minlength: "The zip code must have at least 3 characters",
                    maxlength: "The zip code cannot exceed 191 characters"
                },
                profile: {
                    required: "The profile is required"
                },
                nurseFacultyNursingDegrees: {
                    required: "The nursing faculty degrees is required"
                },
                nurseFacultyNursingSchoolAttended: {
                    required: "The nursing school i graduate from is required"
                },
                nurseFacultySpecialty: {
                    required: "The specialty is required"
                },
                nurseFacultyYearsOfExperience: {
                    required: "The year of experience is required"
                },
                nurseFacultyEmployer: {
                    required: "The nursing school i currently teach at is not required"
                },
                nurseFacultyJobTitle: {
                    required: "The job title is not required"
                },
            },
            errorPlacement: function($error, $element){
                var $ele = $($element);
                var $name = $ele.attr("name");
                if(!$ele.hasClass('is-invalid')){
                    $ele.addClass('is-invalid');
                }
                $("."+$name+"_validate").html($($error).text()).show();
            },
            success: function($error, $element) {
                var $ele = $($element);
                var $name = $ele.attr("name");
                if($ele.hasClass('is-invalid')){
                    $ele.removeClass('is-invalid');
                }
                $("."+$name+"_validate").html('').hide();
            },
            submitHandler: function($form) {
                if($("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultyNursingDegrees']").val() == null){
                    $validator.showErrors({ nurseFacultyNursingDegrees: "The nursing faculty degrees is required" });
                    return false;
                }
                if($("#nurseslounge-home-my-profile-edit-modal form select[name='nurseFacultySpecialty']").val() == null){
                    $validator.showErrors({ nurseFacultySpecialty:"The specialty is required"});
                    return false;
                }
                cback($form);
                return false;
            }
        });
    },
    user_profile_edit_request:function($params){
        var $jobsNearMe = $(".nav-underline a[data-id='jobs_near_me']");
        var $degreesForMe = $(".nav-underline a[data-id='degrees_for_me']");
        var $preceptors = $(".nav-underline a[data-id='preceptors']");
        var $ce = $(".nav-underline a[data-id='continuing_education']");
        var $myCalendar = $(".nav-underline a[data-id='my_calendar']");
        var $myCredentialVault = $(".nav-underline a[data-id='my_credentials_vault']");
        var $myFloatPool = $(".nav-underline a[data-id='my_float_pool']");
        var $nursesLounge = $("#nurseslounge-lounge");
        var $scrollerLeft =  $nursesLounge.find(".nav-scroller-left");
        var $scrollerRight =  $nursesLounge.find(".nav-scroller-right");
        $.ajax({
            url:"/myDashboard/myProfile/permissions/addUserRequest",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    var $profile = $data.data.profile_id;
                    if($profile == 1 || $profile == 2){
                        if(!$jobsNearMe.hasClass('d-none')){
                            $jobsNearMe.addClass('d-none');
                        }
                        if(!$degreesForMe.hasClass('d-none')){
                            $degreesForMe.addClass('d-none');
                        }
                        if(!$ce.hasClass('d-none')){
                            $ce.addClass('d-none');
                        }
                        if(!$myCalendar.hasClass('d-none')){
                            $myCalendar.addClass('d-none');
                        }
                        if(!$myCredentialVault.hasClass('d-none')){
                            $myCredentialVault.addClass('d-none');
                        }
                        if(!$scrollerLeft.hasClass('d-none')){
                            $scrollerLeft.addClass('d-none');
                        }
                        if(!$scrollerRight.hasClass('d-none')){
                            $scrollerRight.addClass('d-none');
                        }
                    }else{
                        if($jobsNearMe.hasClass('d-none')){
                            $jobsNearMe.removeClass('d-none');
                        }
                        if($degreesForMe.hasClass('d-none')){
                            $degreesForMe.removeClass('d-none');
                        }
                        if($ce.hasClass('d-none')){
                            $ce.removeClass('d-none');
                        }
                        if($myCalendar.hasClass('d-none')){
                            $myCalendar.removeClass('d-none');
                        }
                        if($myCredentialVault.hasClass('d-none')){
                            $myCredentialVault.removeClass('d-none');
                        }
                        if($scrollerLeft.hasClass('d-none')){
                            $scrollerLeft.removeClass('d-none');
                        }
                        if($scrollerRight.hasClass('d-none')){
                            $scrollerRight.removeClass('d-none');
                        }
                    }
                    if($profile == 6 || $profile == 7){
                        if($preceptors.hasClass('d-none')){
                            $preceptors.removeClass('d-none');
                        }
                    }else{
                        if(!$preceptors.hasClass('d-none')){
                            $preceptors.addClass('d-none');
                        }
                    }
                    if($profile == 4 || $profile == 6 || $profile == 7){
                        if($myFloatPool.hasClass('d-none')){
                            $myFloatPool.removeClass('d-none');
                        }
                    }else{
                        if(!$myFloatPool.hasClass('d-none')){
                            $myFloatPool.addClass('d-none');
                        }
                    }
                    $(".nav.nav-underline").scrollLeft(0);
                    $scrollerLeft.fadeOut();
                    $scrollerRight.fadeIn();
                    libs.refreshBoxFrom('.box-profile', null, function(){
                        nurseslounge_myDashboard_myProfile.profile({user_id:libs.memoryGet('user_id')});
                        if(window.location.pathname == '/myDashboard/myProfile'){
                            nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                        if(window.location.pathname == '/myDashboard/activity') {
                            nurseslounge_myDashboard_activity.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                            var  nlWall = $(window).nurseslounge_myDashboard_wall_get($params, 'nlWall');
                            nlWall.isEmpty({
                                wall_container:function(){
                                    return $("#nurseslounge-home-activity .nurseslounge-home-activity-left .wall-container");
                                }
                            });
                        }
                        if(window.location.pathname == '/myDashboard/colleagues') {
                            nurseslounge_myDashboard_colleagues.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                        if(window.location.pathname == '/myDashboard/degreesForMe') {
                            nurseslounge_myDashboard_degreesForMe.task_list_container(function($container){
                                nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                            });
                        }
                        nurseslounge_myDashboard_activity.lounge_follow_request(function($chtml){
                            nurseslounge_myDashboard_myProfile.lounge_follow_container($chtml);
                        });
                        nurseslounge_lounge_header.followers_reload_last();
                        $("#nurseslounge-home-my-profile-edit-modal").modal('hide');
                    });
                }
            }
        });
    },
    //Connect With
    connect_with:function(cback){
        cback({
            'connect':$("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .connect-with")
        });
    },
    connect_engine:function($config){
        $config.connect.unbind().click(function(){
            var $toUserId = $(this).data('id');
            var $url = $(this).data('url');
            var $name = $(this).data('name');
            nurseslounge_myDashboard_colleagues.colleagues_invitation_modal($url, $name, function($ok){
                if($ok){
                    var $params = {user_id:libs.memoryGet('user_id'),to_user_id:$toUserId, status_id:1};
                    nurseslounge_myDashboard_colleagues.colleagues_home_set($params, function () {
                        router.navigate('/profile/'+$toUserId);
                    });
                }
            });
        });
    },
    //Banners
    banners_location:function(cback){
        cback({
            'banners':$("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .banners")
        });
    },
    banners_engine:function($config){
        var $userId = libs.memoryGet('user_id');
        var $key = $config.banners.data('key');
        $key = $key == undefined ? '' : $key;
        var $banners = $config.banners.not('.slick-initialized');
        try {
            $banners.slick('unslick');
        } catch (e) {
        }
        var $widget = $banners.parents('.banners-container:first');
        $.ajax({
                url: "/myDashboard/myProfile/banners",
                method: "POST",
                cache: false,
                dataType: "json",
                data: {
                    user_id: $userId,
                    key: $key
                },
                success: function ($data) {
                    libs.expire($data);
                    $banners.width($widget.width());
                    var $chtml = '';
                    if ($data.status == 'success') {
                        $.each($data.data.advertisements, function($i, $v){
                            $chtml+='<div class="col-12 open-url cursor-pointer" data-id="'+$v.id+'">';
                            $chtml+='   <img src="'+$v.advertisement_photo_root+'" class="img-fluid">';
                            $chtml+='</div>';
                        });
                        libs.checkImageLoad($($chtml).find('img'), function(){
                            $banners.width($widget.width());
                            $banners.html($chtml).promise().done(function(){
                                $banners.on('init', function () {
                                    $banners.find('.open-url').unbind().click(function(){
                                        var $id = $(this).data('id');
                                        $.ajax({
                                            url: "/myDashboard/myProfile/banners/visits",
                                            method: "POST",
                                            cache: false,
                                            dataType: "json",
                                            data: {
                                                user_id: $userId,
                                                id:$id
                                            },
                                            success: function ($data) {
                                                if($data.data.advertisement_url){
                                                    window.open($data.data.advertisement_url, '_blank', '');
                                                }
                                            }
                                        });
                                    });
                                }).slick({
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    autoplay: true,
                                    autoplaySpeed: 5000,
                                    arrows: false,
                                    dots: false,
                                    pauseOnHover: false
                                });
                            });
                        });
                    }
                }
            });
    },
    lounge_ads_location:function(cback){
        cback({
            'ads':$("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .lounge-ads")
        });
    },
    //Follow Lounges
    lounge_follow_container:function($chtml){
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .follow-lounges").html($chtml);
        });
    },
    //Invite Collegues
    invite_colleagues_engine:function($config){
        var $colleagues = $config.colleagues;
        $colleagues.unbind().click(function(){
            $.ajax({
                url: "/myDashboard/myProfile/invite/preview",
                method: "POST",
                cache: false,
                dataType: "html",
                data: {user_id: libs.memoryGet('user_id')},
                success: function ($chtml) {
                    libs.expire($chtml);
                    nurseslounge_myDashboard_myProfile.invite_colleagues_modal($chtml);
                }
            });
        });
    },
    invite_colleagues_modal:function($chtml){
        var $modal = $("#nurseslounge-invite-colleagues-modal");
        var $colleaguesInput = $modal.find("input[name='colleagues']");
        var $sendInviteList = $modal.find(".send-invite-list");
        var $preview = $modal.find(".preview");
        var $form = $modal.find("form");
        $colleaguesInput.unbind();
        var $multiEmail = $colleaguesInput.unbind().multiEmail({
            delete: true,
            target:$sendInviteList,
            model:'' +
                '<li class="list-group-item bg-light item" data-email="@email">' +
                '    <a href="javascript:void(0)" class="float-right email-remove">' +
                '        <img src="/bimg/NursesLounge/x-circle.png">' +
                '    </a>' +
                '    <div class="col-12 float-left exist">' +
                '       <a href="@link" target="_blank">' +
                '           <button type="button" class="btn btn-save btnAnimate mt-2 w-100">' +
                '               <i class="fa fa-eye"></i>&nbsp;' +
                '               @email already has an account.' +
                '           </button>' +
                '       </a>' +
                '   </div>' +
                '    <div class="col-12 float-left not_exist">' +
                '       <button type="button" class="btn btn-save btnAnimate mt-2 email-send w-100">' +
                '           <i class="fa fa-send"></i>&nbsp;' +
                '           send invite to @email .' +
                '       </button>' +
                '   </div>' +
                '</li>',
            removeEle:'.email-remove',
            emailSend:'.email-send',
            ajax:{
                method:'POST',
                url:'/myDashboard/myProfile/invite/exist',
                data:{
                    user_id:libs.memoryGet('user_id')
                },
                dataType:'json'
            },
            callback:function($emails){
                var $userId = libs.memoryGet('user_id');
                nurseslounge_myDashboard_myProfile.invite_colleagues_request($emails, function () {
                   if(window.location.pathname == '/myDashboard/activity') {
                       nurseslounge_myDashboard_accountSettings.coins({user_id:$userId});
                       nurseslounge_myDashboard_activity.task_list_container(function($container){
                            nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                        });
                    }
                    if(window.location.pathname == '/myDashboard/colleagues') {
                        nurseslounge_myDashboard_accountSettings.coins({user_id:$userId});
                        nurseslounge_myDashboard_colleagues.task_list_container(function($container){
                            nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                        });
                    }
                    $multiEmail.delete();
                    //$modal.modal('hide');
                });
            }
        });
        $sendInviteList.html('');
        $multiEmail.delete();
        $multiEmail.selector;
        $form.unbind().submit(function ($e) {
            $e.preventDefault();
            if($colleaguesInput.val() != ''){
                var $event = $.Event("keydown",{keyCode:32});
                $colleaguesInput.trigger($event);
            }
        });
        nurseslounge_myDashboard_myProfile.invite_colleagues_autocomplete(
            $colleaguesInput,
            {
                user_id:libs.memoryGet('user_id')
            },
            '/myDashboard/allUsers/get'
        );
        $preview.html($chtml).promise().done(function(){
            $modal.modal('show');
        });
    },
    invite_colleagues_autocomplete:function($target, $data, $url, cback){
        try {
            $($target).autocomplete("destroy");
        }catch (e) {
        }
        var $value = '';
        var $longName = [];
        $($target).autocomplete({
            minLength	:2,
            search		: function(){
                $(this).addClass("ui-autocomplete-loading");
            },
            open 		: function(){
                $(this).removeClass("ui-autocomplete-loading");
            },
            source: function(request, response) {
                $.ajax({
                    method: 'POST',
                    url:$url,
                    data:$.extend({},{
                        search:$($target).val()
                    }, $data),
                    dataType: "json",
                    success: function($data){
                        libs.expire($data);
                        $value = '';
                        response($data.data.emails);
                    }
                });
            },
            create:function(){
                $(this).prev().remove();
                $(this).trigger("keypress.autocomplete");
            },
            select: function (event, ui) {
                $value = ui.item.value;
                $(this).val($value);
                cback($value);
                return false;
            }
        }).keypress(function ($e) {
            if ($e.which == 13) {
                cback($(this).val());
                $(this).autocomplete("close");
            }
        });
    },
    invite_colleagues_request:function($emails, cback){
        $.ajax({
            url: "/myDashboard/myProfile/invite/colleagues",
            method: "POST",
            cache: false,
            dataType: "json",
            data: {
                user_id: libs.memoryGet('user_id'),
                emails: $emails
            },
            success: function ($data) {
                libs.expire($data);
                cback();
            }
        });
    },
    //Recommended Friends
    recommended_friends_container:function($chtml){
        if($chtml == ''){
            $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .invite-colleagues").parents('.card:first').remove();
            return false;
        }
        libs.checkImageLoad($($chtml).find('img'), function(){
            $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .invite-colleagues").html($chtml).promise().done(function(){
                $(this).find(".open-profile").unbind().click(function(){
                    var $guestId = $(this).data('id');
                    router.navigate('/profile/'+$guestId);
                });
                $(this).find(".send-friend-request").unbind().click(function($e){
                    $e.stopPropagation();
                    var $li = $(this).parents('li:first');
                    var $toUserId = $li.data('id');
                    var $name = $li.data('name');
                    var $url = $li.data('url');
                    nurseslounge_myDashboard_colleagues.colleagues_invitation_modal($url, $name, function($ok){
                        if($ok){
                            $li.fadeOut().remove();
                            var $params = {user_id:libs.memoryGet('user_id'),to_user_id:$toUserId, status_id:1};
                            nurseslounge_myDashboard_colleagues.colleagues_home_set($params, function () {
                                nurseslounge_myDashboard_colleagues.init($params);
                            });
                        }
                    });
                });
            });
        });
    },
    //Profile Is Complete Engine
    profile_is_complete:function($params, $isDashboardSetting, cback){
        var $chtml = '';
        var $modal = $("#nurseslounge-home-my-profile-edit-modal");
        var $modalTitle = $modal.find('.modal-title');
        nurseslounge_myDashboard_myProfile.profile_is_complete_request($params, function($data){
            nurseslounge_myDashboard_myProfile.previous_pop_up($data, $isDashboardSetting, function(){
                if($isDashboardSetting){
                    $modal.unbind().on('hide.bs.modal', function () {
                        if($modalTitle.data('tour') == 1){
                            nurseslounge_lounges_tour.init({profile_id:$data.data.profile_id});
                        }
                    });
                    $chtml = '' +
                        '<div class="col-2 offset-5 mt-3">' +
                        '   <img src="/bimg/Login/small-logo.jpeg" class="img-fluid">' +
                        '</div>' +
                        '<h5 class="text-center mt-4">Dashboard Settings</h5>' +
                        '<div class="mt-3">' +
                        '   <h6 class="text-center">' +
                        '       This information is private. We will not give or sell this information to a third party. We use this information to deliver accurate and relevant content to your dashboard.' +
                        '   </h6>' +
                        '</div>';
                    libs.checkImageLoad($($chtml).find('img'), function(){
                        $modalTitle.html($chtml).promise().done(function(){
                            if(cback != undefined){
                                $modalTitle.data('tour', 0);
                                cback();
                            }else{
                                if($data.data.zip_code == null){
                                    $modalTitle.data('tour', 1);
                                    nurseslounge_myDashboard_myProfile.user_profile_fill($params, $isDashboardSetting);
                                    nurseslounge_myDashboard_myProfile.profile_events($params);
                                }
                            }
                        });
                    });
                }else{
                    $chtml = '' +
                        '<h5>Edit Profile Overview</h5>';
                    libs.checkImageLoad($($chtml).find('img'), function(){
                        $modalTitle.html($chtml).promise().done(function(){
                            if(cback != undefined){
                                $modalTitle.data('tour', 0);
                                cback();
                            }
                        });
                    });
                }
            });
        });
    },
    profile_is_complete_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/isComplete",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Previous PopUp
    previous_pop_up:function($data, $isDashboardSetting, execute){
        var $profileId = $data.data.profile_id;
        var $firstTime = $data.data.first_time;
        var $modal = $("#nurseslounge-welcome-modal");
        var $modalBody = $modal.find('.modal-body');
        var $modalInfo = $modalBody.find('.modal-info');
        var $chtml = '';
        if($firstTime == 1 && $isDashboardSetting){ //Non nurse
            if($profileId == 1 || $profileId == 2){
                $chtml = '' +
                    '<div class="modal-texthead content">' +
                    '   <div class="row">' +
                    '       <div class="col-12">' +
                    '           <h4>Your Privacy is Important to Us</h4>' +
                    '           <p>We will never sell or give your information to third parties.' +
                    ' No one on Nurses Lounge has access to your information or can contact you directly.' +
                    ' We use your information to deliver relevant and accurate content to your dashboard.</p>' +
                    '           <hr>' +
                    '           <h4>Own Your Organization’s Lounge Page</h4>' +
                    '           <p>If you want to share jobs, events, hiring incentives, news and other information with nurses then you must be an owner of your organization’s Lounge page.' +
                    ' Get started and you can search for your organization’s page to complete the form and become an owner.' +
                    ' Only schools, employers and professional nurse associations can have Lounge pages.</p>' +
                    '           <div class="custom-control custom-checkbox text-center">' +
                    '               <input type="checkbox" class="custom-control-input" id="thanks" name="agree">' +
                    '               <label class="custom-control-label" for="thanks">Thanks for letting me know</label>' +
                    '           </div>' +
                    '           <button class="btn btn-block start-btn btnAnimate mt-5" disabled>Get Started</button>' +
                    '       </div>' +
                    '   </div>' +
                    '</div>';
            }else{
                $chtml = '' +
                    '<div class="modal-texthead content">' +
                    '   <div class="row">' +
                    '       <div class="col-12">' +
                    '           <h4>Your Privacy is Important to Us</h4>' +
                    '           <p>We will never sell or give your information to third parties.' +
                    ' No one on Nurses Lounge has access to your information or can contact you directly.' +
                    ' We use your information to deliver relevant and accurate content to your dashboard.</p>' +
                    '           <hr>' +
                    '           <h4>Anonymous Ratings & Reviews</h4>' +
                    '           <p>Your experiences as a nurse matter.' +
                    ' Rate past and present employers as well as nursing programs 1 to 5 stars.' +
                    ' Leave an optional review to describe your experiences.' +
                    ' Your ratings and reviews are 100% anonymous. Organizations can not see who created them.</p>' +
                    '           <div class="custom-control custom-checkbox text-center">' +
                    '               <input type="checkbox" class="custom-control-input" id="thanks" name="agree">' +
                    '               <label class="custom-control-label" for="thanks">Thanks for letting me know</label>' +
                    '           </div>' +
                    '           <button class="btn btn-block start-btn btnAnimate mt-5" disabled>Get Started</button>' +
                    '       </div>' +
                    '   </div>' +
                    '</div>';
            }
            $modalInfo.html($chtml).promise().done(function(){
                var $agreeCheckbox = $modalInfo.find('input[name="agree"]');
                var $startBtn = $modalInfo.find('.start-btn');
                $agreeCheckbox.unbind().click(function(){
                    if($agreeCheckbox.is(':checked')){
                        $startBtn.unbind().click(function(){
                            $modal.on('hidden.bs.modal', function ($e) {
                                execute();
                            }).modal('hide');
                        });
                        $startBtn.prop('disabled', false);
                    }else{
                        $startBtn.prop('disabled', true);
                    }
                });
                $modal.modal('show');
            });
        }else{
            execute();
        }
    },
    //Task Container
    task_list_container:function(cback){
        var $modal = $("#nurseslounge-home-myinbox-no-task");
        var $container = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right");
        var $noThank = $container.find(".no-thank");
        var $params = {user_id:libs.memoryGet('user_id')};
        $noThank.unbind().click(function(){
            var $keepIt = $modal.find(".keep-it");
            var $dissmisIt = $modal.find(".dismiss-it");
            $keepIt.unbind().click(function(){
                $modal.modal('hide');
            });
            $dissmisIt.unbind().click(function(){
                nurseslounge_myDashboard_myProfile.task_list_container_request($params, function($data){
                    $modal.modal('hide');
                });
            });
            $modal.modal('show');
        });
        cback($container);
    },
    //Task Engine
    task_list_container_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/dismissList",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(window.location.pathname == '/myDashboard/myProfile') {
                    nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                if(window.location.pathname == '/myDashboard/activity') {
                    nurseslounge_myDashboard_activity.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                if(window.location.pathname == '/myDashboard/colleagues') {
                    nurseslounge_myDashboard_colleagues.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                cback($data);
            }
        });
    },
    task_list:function($container, $params){
        var $taskListContainer = $container.find('.task-list-container:first');
        var $cardTitle = $taskListContainer.find('.card-title:first');
        var $taskListList = $taskListContainer.find('.task-list:first');
        var $forOwners = null;
        var $show = null;
        nurseslounge_myDashboard_myProfile.task_list_request($params, function($data){
            var $chtml = '';
            $forOwners = $data && $data.data && $data.data.task_list && $data.data.task_list[0] ? $data.data.task_list[0].for_owners : 0;
            var $progress = $data.data.progress;
            var $taskList = $data.data.task_list;
            if($taskList.length > 0){
                if($progress != 100){
                    $.each($taskList, function($i, $v){
                        if($v.status){
                            $chtml+= '<li class="checked" ' +
                                'data-id="'+$v.id+'" ' +
                                'data-title="'+$v.task+'" ' +
                                'data-video="'+$v.video+'" ' +
                                'data-loungekey="'+$v.lounge_key+'" ' +
                                'data-loungetypeid="'+$v.lounge_type_id+'" ' +
                                '>'+$v.task+'</li>';
                        }else{
                            $chtml+= '<li ' +
                                'data-id="'+$v.id+'" ' +
                                'data-title="'+$v.task+'" ' +
                                'data-video="'+$v.video+'" ' +
                                'data-loungekey="'+$v.lounge_key+'" ' +
                                'data-loungetypeid="'+$v.lounge_type_id+'" ' +
                                '>'+$v.task+'</li>';
                        }
                    });
                    if($forOwners == 1){
                        $cardTitle.html('' +
                            'Monthly Progress' +
                            '<p class="text-soft mt-2 text-justify">' +
                            ' Complete the tasks to maximize reach to nurse dashboards. Tasks reset each month. ' +
                            '</p>' +
                            '<div class="task-progress progress my-2">' +
                            '   <div class="progress-bar" role="progressbar" style="width: '+$progress+'%;" aria-valuenow="'+$progress+'" aria-valuemin="0" aria-valuemax="100">' +
                            '   </div>' +
                            '   <div class="col-12 mt-2 text-center">' +
                            '       <small>' +
                            $progress+ '%' +
                            '       </small>' +
                            '   </div>' +
                            '</div>' +
                            '');
                        $show = true;
                    }
                    if($forOwners == 0){
                        $cardTitle.html('' +
                            'Getting Started' +
                            '<p class="text-soft mt-2 text-justify">' +
                            ' Here are few tasks to help you get started. Click on the tasks below to watch videos.' +
                            '</p>' +
                            '<div class="task-progress progress my-2">' +
                            '   <div class="progress-bar" role="progressbar" style="width: '+$progress+'%;" aria-valuenow="'+$progress+'" aria-valuemin="0" aria-valuemax="100">' +
                            '   </div>' +
                            '   <div class="col-12 mt-2 text-center">' +
                            '       <small>' +
                            $progress+ '%' +
                            '       </small>' +
                            '   </div>' +
                            '</div>' +
                            '');
                        $show = true;
                    }
                }else{
                    if($forOwners == 1){
                        $cardTitle.html(
                            'Congratulations!' +
                            '<p class="text-soft mt-2 text-justify">' +
                            ' You have completed all monthly tasks. Keep creating content to extend your reach even more! ' +
                            '</p>' +
                            '<div class="task-progress progress my-2">' +
                            '   <div class="progress-bar" role="progressbar" style="width: '+$progress+'%;" aria-valuenow="'+$progress+'" aria-valuemin="0" aria-valuemax="100">' +
                            '   </div>' +
                            '   <div class="col-12 mt-2 text-center">' +
                            '       <small>' +
                            $progress+ '%' +
                            '       </small>' +
                            '   </div>' +
                            '</div>' +
                            '');
                        $show = true;
                    }
                    if($forOwners == 0){
                        $show = false;
                    }
                }
                $taskListList.html($chtml).promise().done(function(){
                    nurseslounge_myDashboard_myProfile.task_list_events($container, $params);
                    if($show == true){
                        $taskListContainer.fadeIn();
                    }
                    if($show == false || $chtml == ''){
                        $taskListContainer.hide();
                    }
                });
            }
        });
    },
    task_list_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/taskList",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    task_list_events:function($container, $params){
        var $taskList = $container.find('.task-list:first');
        var $taskListLi = $taskList.find('li');
        var $modal = $("#nurseslounge-home-tasklist-modal");
        var $modalTitle = $modal.find(".modal-title");
        var $try = $modal.find('.try:first');
        var $reviewModal = $("#nurseslounge-lounge-information-review-modal");
        var $key = $params && $params.key ? $params.key : null;
        $taskListLi.unbind().click(function(){
            var $that = $(this);
            var $title = $that.data('title');
            var $id = $that.data('id');
            var $video = $that.data('video');
            var $loungeKey = $that.data('loungekey');
            var $loungeTypeId = $that.data('loungetypeid');
            switch($id){
                case 1:
                    $try.unbind().click(function(){
                        $params = {user_id:libs.memoryGet('user_id')};
                        $modal.modal('hide');
                        router.navigate('/myDashboard/myProfile');
                        nurseslounge_myDashboard_myProfile.profile_is_complete($params, true, function(){
                            nurseslounge_myDashboard_myProfile.user_profile_fill($params, true);
                            nurseslounge_myDashboard_myProfile.profile_events($params);
                            $("#nurseslounge-home-my-profile-edit-modal .change-password").hide();
                        });
                    });
                    break;
                case 2:
                case 3:
                    $try.unbind().click(function(){
                        $params = {user_id:libs.memoryGet('user_id'), tab:'review_init', key:$loungeKey};                        $modal.modal('hide');
                        router.navigate('/lounge/'+$loungeKey+'/ratingReviews');
                        nurseslounge_lounge_ratingReviews.reviews_get($params, function($data){
                            nurseslounge_lounge_overview.information_review($loungeTypeId, $params, $data, function(){
                                libs.refreshBoxFrom('.review-box', $params, function(){
                                    nurseslounge_lounge_ratingReviews.init($params);
                                    $reviewModal.modal('hide');
                                });
                            });
                        });
                    });
                    break;
                case 4:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        router.navigate('/myDashboard/jobsNearMe');
                    });
                    break;
                case 5:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        router.navigate('/myDashboard/degreesForMe');
                    });
                    break;
                case 6:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        router.navigate('/articles');
                    });
                    break;
                case 7:
                    $try.unbind().click(function(){
                        $params = {user_id:libs.memoryGet('user_id'), choose:'activity'};
                        if($key != null){
                            $params = $.extend({}, $params, {key:$key});
                        }
                        $modal.modal('hide');
                        nurseslounge_myDashboard_myProfile.choose_lounge($params, function($loungeKey){
                            router.navigate('/lounge/'+$loungeKey+'/activity');
                        });
                    });
                    break;
                case 8:
                    $try.unbind().click(function(){
                        $params = {user_id:libs.memoryGet('user_id'), choose:'jobs'};
                        if($key != null){
                            $params = $.extend({}, $params, {key:$key});
                        }
                        $modal.modal('hide');
                        nurseslounge_myDashboard_myProfile.choose_lounge($params, function($loungeKey, $loungeSection){
                            router.navigate('/lounge/'+$loungeKey+'/'+$loungeSection);
                            $params = {
                                user_id:libs.memoryGet('user_id'),
                                action:'info',
                                tab:'jobs',
                                key:$loungeKey
                            };
                            nurseslounge_lounge_nursingJobs.nursing_jobs_up_request($params, function($data){
                                var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
                                $credential = $credential.map(function($x){return parseInt($x);});
                                var $allowTabs = {
                                    'job_information':  $.inArray(19, $credential) != -1 ? true : false,
                                    'job_location':  $.inArray(19, $credential) != -1 ? true : false
                                };
                                var $allowTabsFiltered = $allowTabs;
                                $allowTabs = {};
                                $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
                                var $tab = null;
                                $.each($allowTabs, function($i, $v){
                                    if($v){
                                        $tab = $i;
                                        return false;
                                    }
                                });
                                nurseslounge_job_jobDetail.information_request_select_tab('create', $tab, $allowTabs, $params, function () {
                                    $("#nurseslounge-job-information-edit-modal").scrollTop(0);
                                    $("#nurseslounge-job-information-edit-modal").modal('show');
                                });
                            });
                        });
                    });
                    break;
                case 9:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        nurseslounge_myDashboard_myArticles.section = 'editor';
                        router.navigate('/myDashboard/myArticles');
                    });
                    break;
                case 10:
                    $try.unbind().click(function(){
                        $params = {user_id:libs.memoryGet('user_id'), choose:'invite'};
                        if($key != null){
                            $params = $.extend({}, $params, {key:$key});
                        }
                        $modal.modal('hide');
                        nurseslounge_myDashboard_myProfile.choose_lounge($params, function($loungeKey){
                            router.navigate('/lounge/'+$loungeKey+'/overview');
                            $params = {
                                user_id:libs.memoryGet('user_id'),
                                tab:'init',
                                key:$loungeKey
                            };
                            nurseslounge_lounge_overview.information_lounge_get('init', $params, function($data){
                                var $isEmployer = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 1 : false;
                                var $isSchool = $data && $data.data && $data.data.lounge && $data.data.lounge.lounge_type_id ? $data.data.lounge.lounge_type_id == 2 : false;
                                var $credential = $data && $data.data && $data.data.user_credential ? $data.data.user_credential : [];
                                $credential = $credential.map(function($x){return parseInt($x);});
                                var $allowTabs = {
                                    'information': $.inArray(7, $credential) != -1 ? true : false,
                                    'otherNames': $.inArray(62, $credential) != -1 ? true : false,
                                    'specialties': $.inArray(80, $credential) != -1 && $isSpecialty ? true : false,
                                    'location':    $.inArray(8, $credential) != -1 ? true : false,
                                    'multimedia':  $.inArray(9, $credential) != -1 ? true : false,
                                    'virtualTour':  $.inArray(83, $credential) != -1 ? true : false,
                                    'recruiters':  $.inArray(10, $credential) != -1 ? true : false,
                                    'owners':  $.inArray(11, $credential) != -1 ? true : false,
                                    'jobs':  $.inArray(12, $credential) != -1 && $isEmployer || $.inArray(12, $credential) != -1 && $isSchool ? true : false,
                                    'import':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
                                    'api':  $.inArray(13, $credential) != -1 && $isEmployer || $.inArray(13, $credential) != -1 && $isSchool ? true : false,
                                    'statistics':  $.inArray(14, $credential) != -1 ? true : false,
                                    'degrees':  $.inArray(17, $credential) != -1 && $isSchool ? true : false,
                                    'invite':  $.inArray(24, $credential) != -1 ? true : false,
                                    'inviteStatistics':  $.inArray(28, $credential) != -1 ? true : false,
                                    'inviteTemplates':  $.inArray(66, $credential) != -1 ? true : false,
                                    'createLogo':  $.inArray(67, $credential) != -1 ? true : false,
                                    'buyAds':  $.inArray(71, $credential) != -1 && $isSchool ? true : false,
                                    'sponsorDegrees':  $.inArray(75, $credential) != -1 && $isSchool ? true : false,
                                    'spotlightJobs':  $.inArray(77, $credential) != -1 && !$isSchool ? true : false,
                                };
                                var $allowTabsFiltered = $allowTabs;
                                $allowTabs = {};
                                $.each($allowTabsFiltered, function($k, $v) {var $newObj = {};$newObj[$k]=$v;if($v){$.extend($allowTabs, $newObj);}});
                                var $tab = null;
                                $.each($allowTabs, function($i, $v){
                                    if($v && $i == 'invite'){
                                        $tab = $i;
                                        return false;
                                    }
                                });
                                nurseslounge_lounge_overview.information_administrator_select_tab('edit', $tab, $allowTabs, $params, function () {
                                    $("#nurseslounge-lounge-information-edit-modal").scrollTop(0);
                                    $("#nurseslounge-lounge-information-edit-modal").modal('show');
                                });
                            });
                        });
                    });
                    break;
                case 11:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        router.navigate('/myDashboard/colleagues');
                    });
                    break;
                case 12:
                    $try.unbind().click(function(){
                        $params = {user_id:libs.memoryGet('user_id'), choose:'needAnswer'};
                        if($key != null){
                            $params = $.extend({}, $params, {key:$key});
                        }
                        $modal.modal('hide');
                        nurseslounge_myDashboard_myProfile.choose_lounge($params, function($loungeKey){
                            router.navigate('/lounge/'+$loungeKey+'/ratingReviews');
                        });
                    });
                    break;
                case 13:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        router.navigate('/lounge/'+$key+'/calendar');
                    });
                    break;
                case 14:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        $("#content .image-change").click();
                    });
                    break;
                case 15:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        if(window.location.pathname == '/myDashboard/myProfile'){
                            var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
                            var $experience = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-experience:first');
                            $experience.find(".add-experience:first").click();
                        }else{
                            router.navigate('/myDashboard/myProfile');
                        }
                    });
                    break;
                case 16:
                    $try.unbind().click(function(){
                        $modal.modal('hide');
                        if(window.location.pathname == '/myDashboard/myProfile'){
                            var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
                            var $education = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-education:first');
                            $education.find(".edit-profile:first").click();
                        }else{
                            router.navigate('/myDashboard/myProfile');
                        }
                    });
                    break;
            }
            $modalTitle.html($title).promise().done(function(){
               $modal.unbind().on('shown.bs.modal', function(){
                    nurseslounge_myDashboard_myProfile.task_list_open_youtube($id, $video);
                });
                $modal.modal('show');
            });
        });
    },
    task_list_open_youtube:function($id, $video){
        var $userId = libs.memoryGet('user_id');
        var $youtubePlayer;
        var $modal = $("#nurseslounge-home-tasklist-modal");
        var $videoDiv = $modal.find('.video:first');
        $videoDiv.replaceWith('<div class="video"></div>');
        $videoDiv = $modal.find('.video:first');
        var $urlVideo = new URL($video);
        var $videoId = $urlVideo.searchParams.get('v');
        var $params = {id:$id, user_id:$userId};
        nurseslounge_myDashboard_myProfile.task_list_open_video_request($params, function(){
            $youtubePlayer = libs.memoryGet('youtubePlayer');
            if($youtubePlayer){
                $youtubePlayer.destroy();
            }
            try{
                $youtubePlayer = new YT.Player($videoDiv[0], {
                    height: '360',
                    width: '100%',
                    videoId: $videoId,
                    playerVars: {'autoplay': 1, 'controls': 1},
                    events: {
                        'onReady': function () {
                            $youtubePlayer.mute();
                            $youtubePlayer.playVideoAt(0);
                        },
                        'onError': function () {
                            $videoDiv.hide();
                            libs.memorySave('youtubePlayer', null);
                            nurseslounge_myDashboard_myProfile.task_list_open_youtube($id, $video);
                        }
                    }
                });
            }catch ($e) {

            }
            libs.memorySave('youtubePlayer', $youtubePlayer);
        });
    },
    task_list_open_video_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/taskList/viewed",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(window.location.pathname == '/myDashboard/myProfile') {
                    nurseslounge_myDashboard_myProfile.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                if(window.location.pathname == '/myDashboard/activity') {
                    nurseslounge_myDashboard_activity.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                if(window.location.pathname == '/myDashboard/colleagues') {
                    nurseslounge_myDashboard_colleagues.task_list_container(function($container){
                        nurseslounge_myDashboard_myProfile.task_list($container, {user_id:libs.memoryGet('user_id')});
                    });
                }
                cback($data);
            }
        });
    },
    choose_lounge:function($params, chosen){
        var $chooseLoungeModal = $("#nurseslounge-home-chooselounge-modal");
        var $chooseLoungeModalBody = $chooseLoungeModal.find('.modal-body:first');
        var $chtml = '';
        nurseslounge_myDashboard_myProfile.choose_lounge_request($params, function($data){
            if($data.data.lounges.length > 1){
                $.each($data.data.lounges, function($i, $v){
                    $chtml += '' +
                        '<div class="card-lounge text-center py-4 position-relative">' +
                        '   <div class="profile-img img-objectfit">' +
                        '       <a href="javascript:void(0)" data-key="'+$v.key+'" data-loungetypeid="'+$v.lounge_type_id+'" class="link stretched-link">' +
                        '           <img src="'+$v.logo_root_lounge+'?resize=100" alt="lounge">' +
                        '       </a>' +
                        '   </div>' +
                        '   <div class="list-info align-self-center">' +
                        '       <h4>' +
                        '           <a href="javascript:void(0)" data-key="'+$v.key+'" data-loungetypeid="'+$v.lounge_type_id+'" class="link stretched-link">'+$v.name+'</a>' +
                        '       </h4>' +
                        '   </div>' +
                        '</div>';
                });
                $chooseLoungeModalBody.html($chtml).promise().done(function(){
                    var $links = $chooseLoungeModalBody.find('.link');
                    $links.unbind().click(function(){
                        var $that = $(this);
                        var $key = $that.data('key');
                        var $loungeTypeId = $that.data('loungetypeid');
                        var $section = '';
                        if($loungeTypeId != ''){
                            switch ($loungeTypeId) {
                                case 1:
                                    $section = 'nursingJobs';
                                    break;
                                case 2:
                                    $section = 'nursingFacultyJobs';
                                    break;
                            }
                        }
                        $chooseLoungeModal.modal('hide');
                        chosen($key, $section);
                    });
                    $chooseLoungeModal.modal('show');
                });
            }else
            if($data.data.lounges.length == 1){
                var $lounge = $data.data.lounges[0];
                var $key = $lounge.key;
                var $section = '';
                var $loungeTypeId = $lounge.lounge_type_id;
                switch ($loungeTypeId) {
                    case 1:
                        $section = 'nursingJobs';
                        break;
                    case 2:
                        $section = 'nursingFacultyJobs';
                        break;
                }
                chosen($key, $section);
            }
        });
    },
    choose_lounge_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/chooseLounge/get",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                if(
                    $data.status == 'success'
                ){
                    cback($data);
                }
            }
        });
    },
    //Preview Profile
    preview_profile_container:function(cback){
        var $container = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right");
        cback($container);
    },
    preview_profile:function($container, $params){
        var $previewContainer = $container.find('.preview-profile-container');
        var $previewProfile = $previewContainer.find('.preview-profile:first');
        $previewProfile.unbind().click(function(){
            var $that = $(this);
            var $previewProfile = $that.data('preview_profile');
            $params = $.extend({}, $params, {preview_profile:$previewProfile});
            nurseslounge_myDashboard_myProfile.preview_profile_request($params);
        });
    },
    preview_profile_request:function($params){
        $.ajax({
            url:"/myDashboard/myProfile/setPreviewProfile",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
            }
        });
    },
    //Profile Download PDF
    download_pdf_container:function(cback){
        var $container = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-right .download-profile");
        cback($container);
    },
    download_pdf:function($container, $params){
        var $modal = $("#nurseslounge-lounge-myprofile-download-modal");
        var $pdfContainer = $modal.find('.pdf-container');
        var $download = $modal.find('.download');
        $container.unbind().click(function(){
            $modal.modal('show');
            nurseslounge_myDashboard_myProfile.download_request($params, function($data){
                var $preview = $data.data.preview;
                if(PDFObject.supportsPDFs){
                    PDFObject.embed($preview, $pdfContainer, {
                        height: "400px",
                        pdfOpenParams: {
                            view:'FitH',
                            scrollbars: '0',
                            toolbar: '0',
                            statusbar: '0',
                            navpanes: '0',
                            page:'1'
                        }
                    });
                } else {
                    $pdfContainer.html('<iframe id="pdfviewer" src="http://docs.google.com/gview?embedded=true&url='+$preview+'" frameborder="0" width="100%" height="100%"></iframe>');
                }
                $download.unbind().click(function(){
                    window.open($preview+'?download=1', '_blank');
                });
            });
        });
    },
    download_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/myProfile/preview",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    //Notification Link
    notification_link:function(){
        var $exist = nurseslounge_myDashboard_accountSettings.readCookie('myDashboardMyProfileLeftWrapper');
        if($exist == 1){
            $("#myDashboardMyProfileLeft-wrapper").remove();
        }else{
            $("#myDashboardMyProfileLeft-wrapper .close").unbind().click(function(){
                $("#myDashboardMyProfileLeft-wrapper").remove();
                nurseslounge_myDashboard_accountSettings.createCookie('myDashboardMyProfileLeftWrapper',1,100);
            });
        }
    },
    //Spotlight
    spotlight_container:function(cback){
        var $container = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left .spotlight-wrapper");
        cback($container);
    },
    spotlight:function($container, $params){
        var $chtml = '';
        nurseslounge_myDashboard_myProfile.spotlight_request($params, function($data){
            $.each($data.data.spotlight_jobs, function($i, $v){
                $chtml += nurseslounge_myDashboard_myProfile.spotlight_html($v);
            });
            libs.checkImageLoad($($chtml).find('img'), function () {
                $container.html($chtml).promise().done(function () {
                    var $item = $container.find('.item');
                    $item.unbind().click(function () {
                        var $that = $(this);
                        var $id = $that.data('id');
                        $params = $.extend({}, $params, {'id': $id});
                        nurseslounge_myDashboard_myProfile.spotlight_clicks_request($params, function ($data) {
                            var $spotlightJob = $data.data.spotlight_job
                            var $modal = $("#nurseslounge-myDashboard-spotlight-job-modal");
                            var $image = $modal.find('.image');
                            var $facilityName = $modal.find('label[name="facilityName"]');
                            var $cityState = $modal.find('label[name="cityState"]');
                            var $title = $modal.find('label[name="title"]');
                            var $shift = $modal.find('label[name="shift"]');
                            var $signingBonus = $modal.find('label[name="signingBonus"]');
                            var $compensation = $modal.find('label[name="compensation"]');
                            var $contactEmailUrl = $modal.find('label[name="contactEmailUrl"]');
                            $modal.on('hidden.bs.modal',function($e){
                                $image.attr('src', '/bimg/NursesLounge/loader.gif');
                                $facilityName.html('');
                                $cityState.html('');
                                $title.html('');
                                $shift.html('');
                                $signingBonus.html('');
                                $compensation.html('');
                                $contactEmailUrl.html('');
                            }).modal('hide');
                            $image.attr('src', $spotlightJob.lounge.logo_root_lounge);
                            $title.html($spotlightJob.title);
                            $facilityName.html($spotlightJob.facility_name);
                            $cityState.html($spotlightJob.city_state);
                            $shift.html($spotlightJob.shift);
                            $signingBonus.html($spotlightJob.signing_bonus);
                            $compensation.html($spotlightJob.compensation);
                            if($spotlightJob.contact_is_email){
                                $contactEmailUrl.html('<a class="link-color" target="_blank" href="mailto:'+$spotlightJob.contact_email_url+'">'+$spotlightJob.contact_email_url+'</a>');
                            }else{
                                $contactEmailUrl.html('<a class="link-color" target="_blank" href="'+$spotlightJob.contact_email_url+'">'+$spotlightJob.contact_email_url+'</a>');
                            }
                            $modal.modal('show');
                        });
                    });
                    var $close = $container.find('.close');
                    $close.each(function(){
                        var $that = $(this);
                        var $id = $that.data('id');
                        var $exist = nurseslounge_myDashboard_accountSettings.readCookie('spotlight'+$id);
                        if($exist == 1){
                            $that.parents('.item:first').remove();
                        }else{
                            $that.unbind().click(function(){
                                $that.parents('.item:first').remove();
                                nurseslounge_myDashboard_accountSettings.createCookie('spotlight'+$id,1,100);
                            });
                        }
                    });
                });
            });
        });
    },
    spotlight_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/spotlightJobs",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });

    },
    spotlight_html:function($v){
        var $chtml = '' +
            '<div class="col-12 mb-3 item" data-id="'+$v.id+'">' +
            '    <div class="card card-body pt-1 help-container">' +
            '        <div class="col-12">' +
            '           <span class="float-left pin">' +
            '               <img src="/bimg/NursesLounge/pin.png">' +
            '               <label class="ml-4 top">We found a local job you might like!</label>' +
            '           </span>' +
            '           <span class="float-right close" data-id="'+$v.id+'">X Close</span>' +
            '        </div>' +
            '        <div class="row">' +
            '           <div class="col-lg-2 col-sm-12 mb-2">' +
            '               <img class="logo" src="'+$v.lounge.logo_root_lounge+'">' +
            '           </div>' +
            '           <div class="col-lg-10 col-sm-12 mt-lg-2 pl-lg-0">' +
            '               <h4 class="link-color cursor-pointer">' +
                                $v.title + ' - ' +
                                $v.shift + ' - ' +
                                $v.signing_bonus + ' - ' +
                                $v.compensation + ' - ' +
                                $v.facility_name + ' - ' +
                                $v.city_state +
            '               </h4>' +
            '           </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';

        return $chtml;
    },
    spotlight_clicks_request:function($params, cback){
        $.ajax({
            url:"/myDashboard/myProfile/spotlightClicks",
            method: "POST",
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });

    },
    //Coins
    coin_list_original:[],
    coin_list:function($params, $original, cback){
        nurseslounge_myDashboard_myProfile.coin_list_request($params, function($data){
            var $coinsListIds = $data.data.coins_list_ids;
            if($original){
                nurseslounge_myDashboard_myProfile.coin_list_original = $coinsListIds;
            }
            var $coinsEvents = $data.data.coins_events;
            $('.coin-event').each(function($i, $v){
                var $that = $(this);
                var $id = $that.data('id');
                if($.inArray($id, $coinsListIds) == -1){
                    $that.show();
                }else{
                    $that.hide();
                }
            });
            if(cback != undefined){
                cback($coinsEvents);
            }
        });
    },
    coin_list_request:function($params, cback){
        $.ajax({
            url: "/myDashboard/coin/list",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    coin_events:function($params, $eventsIds){
        $.each($eventsIds, function($i, $v){
            $(".coin-event[data-id='"+$v.id+"']").click(function(){
                var $that = $(this);
                nurseslounge_myDashboard_myProfile.coin_popup($that, $v, function($that, $event){
                    switch($event.id){
                        case 3:
                            //var $profileLeft = $("#nurseslounge-home-my-profile .nurseslounge-home-my-profile-left:first");
                            //var $profile = $profileLeft.find('.nurseslounge-home-my-profile-left-profile-info:first');
                            //$profile.find(".edit-profile:first").click();
                            //var $modal = $("#nurseslounge-home-my-profile-edit-modal");
                            //$modal.unbind().on('hidden.bs.modal', function () {
                                nurseslounge_myDashboard_myProfile.coin_list($params, false, function(){
                                    nurseslounge_myDashboard_myProfile.create_coin($params, $that, 1, $event.coins_number, function(){
                                        alert("");
                                    });
                                });
                            //});
                            break;
                    }
                });
            });
        });
    },
    coin_popup:function($that, $event, cback){
        var $width = $(document).width();
        var $height = $(window).height();
        var $limitTop = ($height/2);
        var $limitLeft = ($width/2) - ($width/4);
        var $limitRight = $limitLeft + ($width/2);
        var $obLeft = $that.offset().left;
        var $obRight = $width - $that.offset().left;
        var $top = $that.offset().top;
        var $windowScrollTop = $(window).scrollTop();
        var $objTop = $top - $windowScrollTop;
        var $zPosition;
        if($limitTop > $objTop){
            $top = $top + 20;
        }else{
            $top = $top - 80;
        }
        //$('body').append('<div style="position:absolute;background: red;left:'+$limitLeft+'px;height: 100%;width: 1px;"></div>');
        //$('body').append('<div style="position:absolute;background: red;left:'+$limitRight+'px;height: 100%;width: 1px;"></div>');
        $(".show-coin-info").remove();
        var $limitRightObj = $obLeft - $limitRight;
        var $limitLeftObj = $obLeft - $limitLeft;
        var $cloRight = $limitRightObj < 0 ? ($limitRightObj * -1) : $limitRightObj;
        var $cloLeft = $limitLeftObj < 0 ? ($limitLeftObj * -1) : $limitLeftObj;
        var $xPosition;
        var $position;
        if($cloRight > $cloLeft){
            $xPosition = 'left';
            if($limitRightObj < 0){
                $position = 'left';
                $obLeft = $obLeft + 14;
            }else{
                $position = 'right';
                $obLeft = $obLeft + 14;
            }
        }else{
            $xPosition = 'right';
            if($limitRightObj < 0){
                $position = 'left';
                $obLeft = $obLeft - 100;
            }else{
                $position = 'right';
                $obLeft = $obLeft - 100;
            }
        }
        var $direction = ['right', 'left', 'alternate'];
        var $index = Math.floor(Math.random() * 3);
        var $coinWrapper = '' +
            '<div class="coin '+$direction[$index]+'" style="margin: 2px 0px 0px 13px;">' +
            '   <div class="front"></div>' +
            '   <div class="front_b"></div>' +
            '   <div class="back"></div>' +
            '   <div class="back_b"></div>' +
            '</div>';
        var $unique = libs.getUniqueId();
        var $chtml = '' +
            '<div id="'+$unique+'" class="show-coin-info cursor-pointer" style="left:'+$obLeft+'px;top:'+$top+'px;">' +
            '   <div class="show-coin-content">' +
            '       <div class="show-coin-content-wrapper">' +
            '           <div>' +
            '               <span class="plus">+</span>' +
            '               <span class="coins">'+$event.coins_number+'</span>' +
            '           </div>' +
            '           <div class="coin-wrapper">' +
            $coinWrapper +
            '           </div>' +
            '       </div>' +
            '       <div class="show-coin-content-info w-100 text-center get-coins">'+$event.goal+'</div>' +
            '   </div>' +
            '</div>';
        $('body').append($chtml).promise().done(function(){
            $("#"+$unique+" .get-coins").unbind().click(function(){
                $("#"+$unique).hide();
                if(cback != undefined){
                    cback($that, $event);
                }
            });
        });
    },
    coin_exist:function($params, cback){
        $.ajax({
            url: "/myDashboard/coin/event/get",
            method: "POST",
            cache:false,
            dataType: "json",
            data:$params,
            success: function ($data) {
                libs.expire($data);
                cback($data);
            }
        });
    },
    create_coin:function($params, $that, $from, $to, cback){
        var $chtml = ''
        var $direction = ['right', 'left', 'alternate'];
        var $index = Math.floor(Math.random() * 3);
        $chtml += '<div class="coin ' + $direction[$index] + '">' +
            '       <div class="front"></div>' +
            '       <div class="front_b"></div>' +
            '       <div class="back"></div>' +
            '       <div class="back_b"></div>' +
            '</div>';
        var $unique = libs.getUniqueId();
        var $ele = '<div id="'+$unique+'" style="position:absolute;margin-top: -45px;">'+$chtml+'</div>';
        //var $width = $(document).width();
        //var $limitLeft = ($width/2) - ($width/4);
        //var $limitRight = $limitLeft + ($width/2);
        //$('body').append('<div style="position:absolute;background: red;left:'+$limitLeft+'px;height: 100%;width: 1px;"></div>');
        //$('body').append('<div style="position:absolute;background: red;left:'+$limitRight+'px;height: 100%;width: 1px;"></div>');
        //var $target  = ($limitRight - $limitLeft);
        //$target = Math.floor(Math.random() * $target);
        //$target = $target + $limitLeft;
        //$('body').append('<div style="position:absolute;background: blue;left:'+$target+'px;height: 100%;width: 1px;"></div>');
        $that.append($ele).ready(function(){
            var $targetCoins = $(".target-coins");
            var $targetTop = $targetCoins.offset().top;
            var $targetLeft = $targetCoins.offset().left;
            $("#"+$unique).animate({
                top: "-=100",
                zoom: '1',
                opacity: 0
            }, 1000, function() {
                if($from < $to){
                    $from = $from+1;
                    setTimeout(function(){
                        nurseslounge_myDashboard_myProfile.create_coin($params, $that, $from, $to, cback);
                    }, Math.floor(Math.random() * 2) * 500);
                }else{
                    if(cback != undefined){
                        cback();
                    }
                }
            });
        });
    },
};
